import { readable } from 'svelte/store';

// version = 2020-06-15 09:43:43;

export const chineseDictStore = readable({ 
	app: {
		 mainTitle: "COVID计算器",
		 subtitle: "一种可视工具，用于探索和分析COVID-19的潜在影响",
		 tabItem0: "死亡率按年龄分布",
		 tabItem1: "其它数据与估值",
		 tabItem2: "风险按国家分布",
		 tabItem3: "贫困率估值",
		 tabItem4: "死亡人数估值",
		 tabItem5: "假设情况",
		 tabItem6: "释例",
		 location: "位置",
		 selectLocation: "选择地点",
		 locationDescription: "各国COVID-19的影响",
		 infectionRate: "感染率",
		 infectionRateDescription: "感染新型冠状病毒总人口比例",
		 over60InfectionRate: "60岁以上感染率",
		 below60InfectionRate: "60岁以下感染率",
		 over60Description: "60岁以上感染新型冠状病毒的人口比例。",
		 proportionIsThen: "然后，将60岁以下的人口比例",
		 proportionIsThenDescription: "因为这取决于总体感染率和60岁以上人群的感染率。",
		 basedOn: "基于",
		 basedOnContinued1: "死亡率和",
		 basedOnContinued2: "的年龄分布和其他选定的输入参数，预计数字",
		 basedOnContinued3: "被感染",
		 basedOnContinued4: "死亡或",
		 basedOnContinued5: "损失的寿命年数",
		 compareWithOtherCaption1: "估计冠状病毒死亡人数可能跨越数年。",
		 compareWithOtherCaption2: "其他原因导致的死亡人数为2017年数据。资料来源：",
		 compareWithOtherCaption3: "因COVID-19确认死亡人数至2020年5月27日。资料来源：",
		 compareWithOtherCaption4: "因其他原因导致寿命损失年数为2017年数据。资料来源：",
		 compareWithOtherCaption5: "直到2020年5月27日，由于COVID-19导致失去的寿命年数。资料来源：",
		 authorsCalculations: "和作者的计算。",
		 compareWithOtherCaption7: "因其他原因而导致的寿命损失年数为2017年数据。资料来源：",
		 proportionOver60ByCountry: "按国家划分的60岁以上风险人群的比例",
		 lowIncomeRiskByCountry: "低收入风险（按国家/地区）",
		 mapCaption: "您可以将鼠标悬停在图例项上以进行选择。您可以放大和缩小地图。然后将鼠标悬停在地图上即可获取有关其代表的国家/地区的信息。",
		 projectedPovery: "按国家分布预计人口增加，这是由于冠状病毒对世界经济的影响，特别对于生活在极端贫困中的人口，指每天低于1.90美元的国际贫困线的收入。",
		 sources: "资料来源：",
		 projectedPoveryByRegion: "由于冠状病毒对世界经济的影响，预计贫困地区会增加。",
		 projectionsCaption: "COVID-19的总死亡人数预测。单击图例以选择或取消选择国家。",
		 source: "资源：",
		 reset: "重置",
		 infectedTitle: "按年龄分布潜在感染人口",
		 deathsTitle: "按年龄划分潜在死亡人口",
		 age: "年龄",
		 infected: "已感染",
		 deaths: "死亡人数",
		 projectionsTitle: "各个国家随时间推移的总死亡人数预测",
		 date: "日期",
		 totDeaths: "死亡总数 (每十万人口)",
		 totDeathsProj: "总死亡人数（预计）",
		 titleListMain: "与COVID-19比较 ",
		 titleListName: "原因",
		 titleListRisk: "风险",
		 titleListNumber: " 在",
		 yearsOfLifeLost: "损失寿命年数",
		 inCountry: " 在",
		 compareItems0: "损失寿命原因",
		 compareItems1: "导致损失寿命的风险",
		 compareItems2: "风险与寿命减短",
		 covid19Cause: "COVID-19（估算）",
		 enterDescribtion: "输入",
		 yrsOfLifeLost: "预期寿命损失",
		 yrsOfLifeLostCosts: "潜在成本",
		 scenariosDescription: "场景描述",
		 povertyTitle: "由于COVID-19，潜在的数百万人陷入极端贫困",
		 country: "国家",
		 region: "区域",
		 people: "人",
		 india: "印度",
		 nigeria: "尼日利亚",
		 drCongo: "刚果民主共和国",
		 ethiopia: "埃塞俄比亚",
		 bangladesh: "孟加拉国",
		 tanzania: "坦桑尼亚",
		 madagascar: "马达加斯加",
		 indonesia: "印尼",
		 kenya: "肯尼亚",
		 mozambique: "莫桑比克",
		 uganda: "乌干达",
		 southAfrica: "南非",
		 subSahAfrica: "撒哈拉以南非洲",
		 southAsia: "南亚",
		 eastAsiaPacific: "东亚与太平洋",
		 latinCaribbean: "拉丁美洲和加勒比海",
		 middleEastNorthAfrica: "中东和北非",
		 europeCentralAsia: "欧洲与中亚",
		 northAmerica: "北美",
		 mainProjRegions: "损失寿命原因",
		 nameProjRegions: "导致损失寿命的风险",
		 numberProjRegions: "风险与寿命减短",
		 fatalityRates: "死亡率",
		 fatalityRatesDescription: "选择因新型冠状病毒感染而导致死亡的估计风险。估算值因国家和地区而异。更广泛的测试可以降低CFR估算值。",
		 varyFRs: "改变选择的死亡率",
		 varyFRsDescription1: "尝试增加死亡风险，例如到50％，适用于低收入国家或不堪重负的医疗保健。",
		 varyFRsDescription2: "或减少，例如达到-50％，以期望得到更好的治疗和更好的医疗保健",
		 resetDescription: "将所有输入参数设置回其初始值。",
		 elimination: "消除COVID-19的可能性",
		 eliminationDescription1: "在感染前完全消除COVID-19疾病的可能性",
		 eliminationDescription2: "人口。",
		 infectionUntil: "直至消除的感染率",
		 infectionUntilDescription: "甚至在完全消除的情况下仍然受到感染的人口比例。注意：首先增加消除此参数的可能性。",
		 hideExport: "隐藏导出",
		 export: "导出",
		 exportDescription: "以JSON格式导出COVID-19的假设情景",
		 export1: "隐藏导出",
		 scenariosCaption: "您可以设置描述一个假设情景的输入参数，并将其添加到表中进行比较。对于选定的位置和死亡风险，有3个假设场景的示例。应谨慎解释结果，请参见示例解释。",
		 exampleScenario0: "场景0：不做任何事情，作为基准",
		 exampleScenario1: "方案1：保护60岁以上的人们，通过暴露60岁以下的人们进行补偿，同时考虑失去的寿命",
		 exampleScenario2: "方案2：消除90％，同时考虑省钱",
		 mapTitle: "COVID-19各国风险",
		 mapItems0: "按国家划分的60岁以上人口的比例",
		 mapItems1: "低收入风险（按国家/地区）",
		 povertyItems0: "按国家",
		 povertyItems1: "按地区",
		},
	fatalityRisks: [
		 {id: 0,
		  source: "帝国理工学院-IFR",
		  ftr: [0.002, 0.006, 0.03, 0.08, 0.15, 0.6, 2.2, 5.1, 9.3] },
		 {id: 1,
		  source: "中国疾病预防控制中心-CFR",
		  ftr: [0, 0.2, 0.2, 0.2, 0.4, 1.3, 3.6, 8, 14.8] },
		 {id: 2,
		  source: "韩国CDC-CFR",
		  ftr: [0, 0, 0, 0.11, 0.08, 0.5, 1.8, 6.3, 13] },
		 {id: 3,
		  source: "JAMA意大利-CFR",
		  ftr: [0, 0, 0, 0.3, 0.4, 1, 3.5, 12.8, 20.2] },
		 {id: 4,
		  source: "MISAN西班牙-CFR",
		  ftr: [0, 0, 0.22, 0.14, 0.3, 0.4, 1.9, 4.8, 15.6] },
		],
	compareOptions: [
		 {id: 0,
		  compareWith: "其他主要死因" },
		 {id: 1,
		  compareWith: "疾病与寿命减短" },
		 {id: 2,
		  compareWith: "风险与寿命减短" },
		 {id: 3,
		  compareWith: "世界其他国家" },
		],
	countries: [
		 {id: 0,
		  name: "阿富汗",
		  lifeExpectancy: 64.83,
		  demographics: [11040694, 9635671, 6779023, 4381488, 2846500, 1773768, 1020779, 458747, 105087],
		  majorCauses: ['心血管疾病', '新生儿疾病', '下呼吸道感染', '癌症', '道路伤害', '呼吸疾病', '脑膜炎', '腹泻病', '恐怖主义', '糖尿病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [56119, 27522, 21431, 16670, 8692, 6917, 6589, 6176, 6092, 5978, 220],
		  diseaseNames: ['腹泻和常见传染病', '新生儿疾病', '冲突与恐怖主义', '心血管疾病', '其他非传染性疾病', '糖尿病，血液和内分泌疾病', '意外伤害', '癌症', '运输伤害', '艾滋病毒/艾滋病与结核病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [2949759, 2461244, 2128416, 1596954, 1539479, 975117, 797604, 601374, 551807, 542777, 4967],
		  riskFactors: ['空气污染（室内和室外）', '浪费孩子', '高血压', '高血糖', '高胆固醇', '肥胖', '不安全的水源', '儿童发育不良', '儿童发育迟缓', '水果饮食偏少', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [1341395, 1306178, 901181, 866085, 807902, 689543, 523650, 475516, 455174, 378229, 4967] },
		 {id: 1,
		  name: "阿尔巴尼亚",
		  lifeExpectancy: 78.57,
		  demographics: [333920, 375307, 481846, 377350, 330419, 392129, 317994, 189973, 81975],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '呼吸疾病', '消化系统疾病', '下呼吸道感染', '肾脏疾病', '肝病', '道路伤害', '帕金森综合症', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [12145, 4345, 1337, 736, 489, 382, 363, 309, 248, 234, 33],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '意外伤害', '神经系统疾病', '精神和物质使用障碍', '其他非传染性疾病', '糖尿病，血液和内分泌疾病', '新生儿疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [206331, 100981, 64286, 53506, 51865, 38507, 37568, 35191, 27693, 24834, 483],
		  riskFactors: ['高血压', '抽烟', '肥胖', '高血糖', '高胆固醇', '空气污染（室内和室外）', '饮食含盐量高', '水果饮食偏少', '二手烟', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [128064, 99946, 69372, 57453, 55471, 37120, 29156, 16674, 13809, 10129, 483] },
		 {id: 2,
		  name: "阿尔及利亚",
		  lifeExpectancy: 76.88,
		  demographics: [9533023, 6466198, 6759761, 7193824, 5249023, 3682969, 2430965, 1179741, 557550],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '道路伤害', '新生儿疾病', '呼吸疾病', '糖尿病', '消化系统疾病', '下呼吸道感染', '肾脏疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [79389, 21656, 8175, 6905, 6511, 5508, 5202, 4800, 4724, 4577, 617],
		  diseaseNames: ['心血管疾病', '其他非传染性疾病', '糖尿病，血液和内分泌疾病', '新生儿疾病', '肌肉骨骼疾病', '精神和物质使用障碍', '癌症', '神经系统疾病', '运输伤害', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1577873, 857655, 809853, 773630, 767622, 694410, 601103, 581302, 441546, 404974, 10657],
		  riskFactors: ['肥胖', '高血压', '高血糖', '抽烟', '高胆固醇', '空气污染（室内和室外）', '用药', '水果饮食偏少', '二手烟', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [956409, 835084, 810448, 541145, 412426, 388376, 354830, 213070, 163252, 146851, 10657] },
		 {id: 3,
		  name: "安哥拉",
		  lifeExpectancy: 61.15,
		  demographics: [10645848, 7583998, 5137763, 3567431, 2316948, 1419872, 744701, 323212, 85526],
		  majorCauses: ['心血管疾病', '新生儿疾病', '腹泻病', 'HIV爱滋病', '下呼吸道感染', '癌症', '结核', '疟疾', '消化系统疾病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [21785, 17882, 17390, 14585, 14508, 12040, 11409, 8431, 8274, 6781, 4],
		  diseaseNames: ['腹泻和常见传染病', '新生儿疾病', '艾滋病毒/艾滋病与结核病', '其他非传染性疾病', '疟疾和被忽视的热带病', '营养不足', '心血管疾病', '意外伤害', '运输伤害', '癌症', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [2327125, 1715532, 1024134, 829609, 816838, 737124, 587699, 479827, 474564, 395113, 91],
		  riskFactors: ['浪费孩子', '不安全的水源', '不安全的卫生', '空气污染（室内和室外）', '高血糖', '儿童发育不良', '高血压', '儿童发育迟缓', '缺铁', '抽烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [1441565, 1065429, 706854, 558639, 474834, 471166, 388213, 342714, 308832, 291488, 91] },
		 {id: 4,
		  name: "阿根廷",
		  lifeExpectancy: 76.67,
		  demographics: [7431085, 7110303, 6989730, 6393900, 5596155, 4365874, 3478296, 2234324, 1181008],
		  majorCauses: ['心血管疾病', '癌症', '下呼吸道感染', '呼吸疾病', '痴呆', '消化系统疾病', '肾脏疾病', '糖尿病', '肝病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [105777, 74066, 31058, 18992, 18617, 14906, 10834, 9345, 7346, 6457, 484],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '意外伤害', '其他非传染性疾病', '神经系统疾病', '腹泻和常见传染病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1850384, 1636213, 1070031, 821073, 755647, 600218, 586346, 572018, 566705, 485965, 7111],
		  riskFactors: ['抽烟', '高血糖', '肥胖', '高血压', '高胆固醇', '空气污染（室内和室外）', '用药', '饮食中蔬菜含量低', '水果饮食偏少', '饮食含盐量高', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [1377562, 1041499, 1039208, 849828, 466427, 374352, 209665, 188972, 182487, 181170, 7111] },
		 {id: 5,
		  name: "亞美尼亞",
		  lifeExpectancy: 75.09,
		  demographics: [421267, 361638, 430188, 495062, 344211, 375592, 312416, 122717, 94637],
		  majorCauses: ['心血管疾病', '癌症', '消化系统疾病', '痴呆', '呼吸疾病', '糖尿病', '肝病', '下呼吸道感染', '肾脏疾病', '自杀', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [13631, 5756, 1720, 1357, 1311, 1142, 1107, 501, 430, 302, 91],
		  diseaseNames: ['心血管疾病', '癌症', '糖尿病，血液和内分泌疾病', '肌肉骨骼疾病', '神经系统疾病', '其他非传染性疾病', '意外伤害', '消化系统疾病', '精神和物质使用障碍', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [232712, 134659, 70952, 55930, 50354, 50085, 45363, 45321, 42045, 33336, 1338],
		  riskFactors: ['高血压', '高血糖', '抽烟', '肥胖', '高胆固醇', '空气污染（室内和室外）', '饮食含盐量高', '水果饮食偏少', '二手烟', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [150086, 147509, 126246, 106265, 76463, 61605, 33567, 31703, 26363, 17455, 1338] },
		 {id: 6,
		  name: "澳大利亚",
		  lifeExpectancy: 83.44,
		  demographics: [3280238, 3079378, 3401525, 3662343, 3282597, 3093653, 2605017, 1768659, 1029790],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '呼吸疾病', '消化系统疾病', '肾脏疾病', '下呼吸道感染', '糖尿病', '自杀', '帕金森综合症', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [52101, 50254, 17119, 10822, 6112, 4455, 4451, 3755, 3055, 2328, 102],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '精神和物质使用障碍', '神经系统疾病', '意外伤害', '呼吸疾病', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [970836, 694335, 645111, 549355, 438634, 432478, 305003, 292021, 244224, 147752, 1386],
		  riskFactors: ['抽烟', '肥胖', '高血压', '高血糖', '高胆固醇', '用药', '空气污染（室内和室外）', '水果饮食偏少', '低体力活动', '饮食中蔬菜含量低', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [522203, 490967, 365301, 358549, 199475, 186884, 93142, 87901, 63860, 58260, 1386] },
		 {id: 7,
		  name: "奥地利",
		  lifeExpectancy: 81.54,
		  demographics: [863022, 877100, 1124426, 1224528, 1195561, 1402944, 1000416, 789863, 477248],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '呼吸疾病', '消化系统疾病', '肾脏疾病', '糖尿病', '肝病', '自杀', '帕金森综合症', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [31386, 21745, 7481, 3383, 3227, 2754, 2059, 1860, 1422, 994, 643],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '意外伤害', '其他非传染性疾病', '消化系统疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [412725, 410715, 249516, 205240, 164586, 148028, 122133, 119273, 104957, 103622, 8364],
		  riskFactors: ['抽烟', '高血压', '高血糖', '肥胖', '高胆固醇', '空气污染（室内和室外）', '饮食含盐量高', '用药', '低体力活动', '水果饮食偏少', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [289316, 247866, 234711, 198890, 118630, 69586, 40222, 38446, 32621, 32476, 8364] },
		 {id: 8,
		  name: "阿塞拜疆",
		  lifeExpectancy: 73.0,
		  demographics: [1680978, 1317438, 1666611, 1724388, 1263973, 1281704, 743188, 232553, 136886],
		  majorCauses: ['心血管疾病', '癌症', '消化系统疾病', '肝病', '下呼吸道感染', '痴呆', '呼吸疾病', '新生儿疾病', '糖尿病', '肾脏疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [40266, 10954, 3940, 3141, 3055, 2482, 2340, 2274, 1752, 1169, 52],
		  diseaseNames: ['心血管疾病', '癌症', '腹泻和常见传染病', '新生儿疾病', '其他非传染性疾病', '糖尿病，血液和内分泌疾病', '意外伤害', '肌肉骨骼疾病', '神经系统疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [821522, 314922, 242153, 241789, 193598, 185831, 167301, 151704, 146958, 135223, 929],
		  riskFactors: ['高血压', '高血糖', '肥胖', '抽烟', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '饮食含盐量高', '二手烟', '浪费孩子', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [510416, 425013, 362881, 334822, 279459, 197950, 127029, 125321, 104163, 86129, 929] },
		 {id: 9,
		  name: "巴哈马",
		  lifeExpectancy: 73.92,
		  demographics: [54179, 64391, 65619, 54838, 56558, 48211, 27694, 13163, 4833],
		  majorCauses: ['心血管疾病', '癌症', '糖尿病', 'HIV爱滋病', '杀人', '下呼吸道感染', '消化系统疾病', '肾脏疾病', '痴呆', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [801, 530, 128, 114, 107, 105, 104, 93, 92, 60, 11],
		  diseaseNames: ['心血管疾病', '癌症', '糖尿病，血液和内分泌疾病', '肌肉骨骼疾病', '人际暴力', '精神和物质使用障碍', '其他非传染性疾病', '艾滋病毒/艾滋病与结核病', '神经系统疾病', '腹泻和常见传染病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [18194, 13979, 12275, 6281, 6124, 6111, 5713, 5541, 5507, 4614, 192],
		  riskFactors: ['肥胖', '高血压', '高血糖', '高胆固醇', '抽烟', '空气污染（室内和室外）', '饮食中蔬菜含量低', '用药', '低体力活动', '饮食含盐量高', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [13121, 11928, 10905, 4719, 4611, 3432, 1440, 1366, 1195, 982, 192] },
		 {id: 10,
		  name: "巴林",
		  lifeExpectancy: 77.29,
		  demographics: [215191, 177424, 318510, 464806, 244359, 137046, 61268, 16906, 5654],
		  majorCauses: ['心血管疾病', '癌症', '糖尿病', '消化系统疾病', '肾脏疾病', '道路伤害', '呼吸疾病', '痴呆', '下呼吸道感染', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [961, 553, 529, 143, 133, 128, 114, 110, 95, 84, 14],
		  diseaseNames: ['糖尿病，血液和内分泌疾病', '肌肉骨骼疾病', '精神和物质使用障碍', '心血管疾病', '神经系统疾病', '其他非传染性疾病', '癌症', '新生儿疾病', '呼吸疾病', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [39073, 32240, 29024, 26949, 19107, 18531, 15791, 10408, 10052, 9970, 339],
		  riskFactors: ['肥胖', '高血糖', '高血压', '空气污染（室内和室外）', '用药', '抽烟', '高胆固醇', '二手烟', '水果饮食偏少', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [36296, 34551, 18126, 14303, 14207, 12588, 11243, 3904, 3635, 3064, 339] },
		 {id: 11,
		  name: "孟加拉国",
		  lifeExpectancy: 72.59,
		  demographics: [29140694, 30882112, 29600040, 26177061, 20143207, 14480320, 6892779, 4064814, 1665146],
		  majorCauses: ['心血管疾病', '癌症', '呼吸疾病', '新生儿疾病', '消化系统疾病', '下呼吸道感染', '糖尿病', '腹泻病', '肝病', '痴呆', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [320563, 99302, 82276, 53449, 44992, 38521, 34564, 30147, 26390, 17256, 522],
		  diseaseNames: ['心血管疾病', '新生儿疾病', '腹泻和常见传染病', '肌肉骨骼疾病', '癌症', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '呼吸疾病', '意外伤害', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [7263655, 5707014, 4266872, 2891058, 2718396, 2592864, 2488098, 2370531, 2224279, 2204327, 9574],
		  riskFactors: ['空气污染（室内和室外）', '高血压', '高血糖', '抽烟', '水果饮食偏少', '高胆固醇', '肥胖', '浪费孩子', '饮食中蔬菜含量低', '饮食含盐量高', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [3871076, 3578773, 2726100, 2320793, 1895086, 1668575, 1459444, 1428511, 1260828, 998683, 9574] },
		 {id: 12,
		  name: "巴巴多斯",
		  lifeExpectancy: 79.19,
		  demographics: [30994, 36993, 37512, 37294, 39394, 40137, 32664, 19336, 12696],
		  majorCauses: ['心血管疾病', '癌症', '糖尿病', '下呼吸道感染', '痴呆', '消化系统疾病', '肾脏疾病', '呼吸疾病', '肝病', '杀人', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [840, 677, 242, 183, 171, 94, 90, 63, 39, 32, 7],
		  diseaseNames: ['心血管疾病', '癌症', '糖尿病，血液和内分泌疾病', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '其他非传染性疾病', '腹泻和常见传染病', '消化系统疾病', '新生儿疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [14552, 14043, 11241, 6037, 5473, 5081, 4386, 3631, 2854, 2533, 94],
		  riskFactors: ['高血糖', '肥胖', '高血压', '抽烟', '空气污染（室内和室外）', '高胆固醇', '水果饮食偏少', '饮食中蔬菜含量低', '低体力活动', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [12710, 11385, 9034, 4139, 3869, 2945, 1803, 1372, 1259, 883, 94] },
		 {id: 13,
		  name: "白俄罗斯",
		  lifeExpectancy: 74.79,
		  demographics: [1134208, 910479, 1147255, 1510155, 1278833, 1374474, 1190629, 533029, 373347],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '消化系统疾病', '饮酒障碍', '肝病', '自杀', '呼吸疾病', '下呼吸道感染', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [73014, 18558, 6550, 4498, 2803, 2533, 2357, 2065, 1175, 990, 208],
		  diseaseNames: ['心血管疾病', '癌症', '意外伤害', '肌肉骨骼疾病', '神经系统疾病', '消化系统疾病', '精神和物质使用障碍', '其他非传染性疾病', '糖尿病，血液和内分泌疾病', '自残', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1238969, 440057, 285451, 218899, 197375, 168700, 162164, 123781, 114503, 89387, 2938],
		  riskFactors: ['高血压', '抽烟', '高胆固醇', '肥胖', '高血糖', '空气污染（室内和室外）', '水果饮食偏少', '饮食含盐量高', '低体力活动', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [813813, 576719, 492857, 471979, 288461, 176297, 173117, 143406, 89321, 62880, 2938] },
		 {id: 14,
		  name: "比利时",
		  lifeExpectancy: 81.63,
		  demographics: [1305219, 1298970, 1395385, 1498535, 1524152, 1601891, 1347696, 908725, 658753],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', 'COVID-19，直到2020年5月27日', '呼吸疾病', '下呼吸道感染', '消化系统疾病', '自杀', '肾脏疾病', '肝病', '糖尿病'],
		  majorDeaths: [32194, 30782, 10550, 9334, 6804, 5669, 5111, 2132, 2097, 2004, 1436],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '意外伤害', '呼吸疾病', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', 'COVID-19，直到2020年5月27日', '消化系统疾病'],
		  diseaseDALYs: [577400, 454391, 354782, 293127, 224452, 180671, 164776, 158502, 140478, 119438, 118342],
		  riskFactors: ['抽烟', '高血糖', '高血压', '肥胖', 'COVID-19，直到2020年5月27日', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '低体力活动', '用药', '二手烟'],
		  riskDALYs: [473420, 278047, 257958, 227091, 119438, 118510, 99170, 66362, 38847, 38280, 34819] },
		 {id: 15,
		  name: "伯利兹",
		  lifeExpectancy: 74.62,
		  demographics: [77702, 78150, 74346, 57769, 42878, 30626, 16843, 7912, 4124],
		  majorCauses: ['心血管疾病', '癌症', '糖尿病', '下呼吸道感染', '杀人', '消化系统疾病', '肾脏疾病', 'HIV爱滋病', '道路伤害', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [424, 277, 126, 111, 106, 92, 84, 81, 72, 69, 2],
		  diseaseNames: ['心血管疾病', '糖尿病，血液和内分泌疾病', '癌症', '新生儿疾病', '其他非传染性疾病', '人际暴力', '精神和物质使用障碍', '意外伤害', '腹泻和常见传染病', '神经系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [9830, 9614, 7583, 7367, 6049, 6027, 5975, 5561, 5539, 4996, 36],
		  riskFactors: ['高血糖', '肥胖', '高血压', '抽烟', '空气污染（室内和室外）', '高胆固醇', '缺铁', '水果饮食偏少', '浪费孩子', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [9631, 9251, 5961, 3571, 3449, 2288, 1745, 1482, 1423, 1253, 36] },
		 {id: 16,
		  name: "贝宁",
		  lifeExpectancy: 61.77,
		  demographics: [3529739, 2708314, 2001076, 1389287, 950137, 627369, 364348, 179593, 51287],
		  majorCauses: ['新生儿疾病', '疟疾', '心血管疾病', '下呼吸道感染', '腹泻病', '癌症', '道路伤害', '结核', '消化系统疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [9627, 9433, 9221, 7565, 6383, 5434, 3093, 2890, 2629, 1983, 3],
		  diseaseNames: ['腹泻和常见传染病', '新生儿疾病', '疟疾和被忽视的热带病', '其他非传染性疾病', '营养不足', '心血管疾病', '糖尿病，血液和内分泌疾病', '艾滋病毒/艾滋病与结核病', '运输伤害', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1295131, 899739, 783500, 359850, 253199, 238944, 238353, 218491, 192950, 180157, 62],
		  riskFactors: ['浪费孩子', '不安全的水源', '空气污染（室内和室外）', '不安全的卫生', '儿童发育不良', '高血压', '高血糖', '儿童发育迟缓', '肥胖', '缺铁', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [589619, 357407, 310177, 279407, 201743, 145002, 138640, 123773, 117511, 109285, 62] },
		 {id: 17,
		  name: "不丹",
		  lifeExpectancy: 71.78,
		  demographics: [126258, 137813, 154517, 134250, 86166, 57026, 35719, 21762, 9582],
		  majorCauses: ['心血管疾病', '癌症', '呼吸疾病', '消化系统疾病', '新生儿疾病', '下呼吸道感染', '肝病', '肾脏疾病', '腹泻病', '痴呆', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [1156, 488, 446, 255, 205, 180, 157, 136, 132, 125, 0],
		  diseaseNames: ['心血管疾病', '腹泻和常见传染病', '新生儿疾病', '肌肉骨骼疾病', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '意外伤害', '癌症', '其他非传染性疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [26845, 24060, 23302, 15553, 14573, 14249, 13641, 13614, 13469, 12218, 0],
		  riskFactors: ['高血压', '高血糖', '空气污染（室内和室外）', '肥胖', '高胆固醇', '缺铁', '抽烟', '水果饮食偏少', '饮食含盐量高', '饮食中蔬菜含量低', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [15575, 12298, 11644, 10068, 9089, 8988, 7745, 5274, 4216, 3631, 0] },
		 {id: 18,
		  name: "玻利維亞",
		  lifeExpectancy: 71.51,
		  demographics: [2365890, 2289751, 2012188, 1605907, 1206917, 859703, 600549, 378817, 193379],
		  majorCauses: ['心血管疾病', '癌症', '下呼吸道感染', '消化系统疾病', '肾脏疾病', '呼吸疾病', '糖尿病', '新生儿疾病', '痴呆', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [15275, 12195, 5360, 4078, 3165, 3122, 2903, 2826, 2651, 2215, 274],
		  diseaseNames: ['腹泻和常见传染病', '心血管疾病', '癌症', '新生儿疾病', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '精神和物质使用障碍', '意外伤害', '肌肉骨骼疾病', '神经系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [360435, 323003, 304397, 303329, 214670, 213058, 172883, 163508, 161009, 146546, 4392],
		  riskFactors: ['高血糖', '肥胖', '高血压', '空气污染（室内和室外）', '抽烟', '浪费孩子', '高胆固醇', '缺铁', '水果饮食偏少', '饮食中蔬菜含量低', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [255825, 202319, 174854, 127408, 100318, 89251, 76483, 70730, 54745, 46823, 4392] },
		 {id: 19,
		  name: "波斯尼亚和黑塞哥维那",
		  lifeExpectancy: 77.4,
		  demographics: [306587, 351419, 409569, 468369, 448869, 508292, 452975, 235035, 119881],
		  majorCauses: ['心血管疾病', '癌症', '糖尿病', '痴呆', '呼吸疾病', '消化系统疾病', '肾脏疾病', '肝病', '下呼吸道感染', '帕金森综合症', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [18107, 8950, 2293, 1991, 1310, 1136, 604, 577, 360, 324, 149],
		  diseaseNames: ['心血管疾病', '癌症', '糖尿病，血液和内分泌疾病', '肌肉骨骼疾病', '意外伤害', '神经系统疾病', '精神和物质使用障碍', '呼吸疾病', '其他非传染性疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [314480, 202956, 96087, 76811, 71590, 67986, 49804, 45325, 40933, 39556, 2127],
		  riskFactors: ['抽烟', '高血糖', '高血压', '肥胖', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '饮食含盐量高', '二手烟', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [215413, 199141, 198050, 137744, 93564, 77913, 45939, 41923, 29708, 23846, 2127] },
		 {id: 20,
		  name: "波札那",
		  lifeExpectancy: 69.59,
		  demographics: [535771, 462584, 397946, 359631, 247537, 141947, 100575, 45935, 11776],
		  majorCauses: ['HIV爱滋病', '心血管疾病', '癌症', '下呼吸道感染', '糖尿病', '腹泻病', '呼吸疾病', '结核', '消化系统疾病', '新生儿疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [4102, 2548, 1487, 768, 668, 577, 510, 444, 438, 436, 1],
		  diseaseNames: ['艾滋病毒/艾滋病与结核病', '腹泻和常见传染病', '糖尿病，血液和内分泌疾病', '心血管疾病', '新生儿疾病', '癌症', '精神和物质使用障碍', '神经系统疾病', '肌肉骨骼疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [290480, 73500, 56387, 54317, 47687, 39229, 34628, 25707, 25706, 25228, 20],
		  riskFactors: ['高血糖', '肥胖', '高血压', '空气污染（室内和室外）', '抽烟', '不安全的水源', '浪费孩子', '不安全的卫生', '用药', '高胆固醇', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [50246, 44707, 38344, 27484, 26951, 23734, 22767, 16393, 13684, 13563, 20] },
		 {id: 21,
		  name: "巴西",
		  lifeExpectancy: 75.88,
		  demographics: [29188180, 31633075, 34181400, 34436184, 28902917, 24026608, 16292185, 8401090, 3987880],
		  majorCauses: ['心血管疾病', '癌症', '下呼吸道感染', '痴呆', '呼吸疾病', '消化系统疾病', '杀人', '糖尿病', '道路伤害', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [388268, 244969, 84073, 73419, 72746, 72556, 63825, 56474, 46282, 36269, 24512],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '人际暴力', '神经系统疾病', '其他非传染性疾病', '腹泻和常见传染病', '新生儿疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [8160380, 5945407, 4516692, 4060910, 3687892, 3645543, 3611498, 3460212, 2648390, 2616371, 395930],
		  riskFactors: ['高血压', '肥胖', '抽烟', '高血糖', '高胆固醇', '空气污染（室内和室外）', '饮食中蔬菜含量低', '用药', '饮食含盐量高', '缺铁', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [4906211, 4890017, 4562909, 3414338, 2207263, 1617178, 1049247, 1024329, 949371, 845115, 395930] },
		 {id: 22,
		  name: "保加利亚",
		  lifeExpectancy: 75.05,
		  demographics: [662976, 671433, 724640, 971335, 1061668, 947156, 936053, 692820, 332035],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '消化系统疾病', '呼吸疾病', '肝病', '糖尿病', '下呼吸道感染', '肾脏疾病', '自杀', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [65619, 18734, 5945, 3543, 3299, 2043, 1584, 1549, 1447, 995, 133],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '意外伤害', '神经系统疾病', '糖尿病，血液和内分泌疾病', '消化系统疾病', '呼吸疾病', '精神和物质使用障碍', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1099367, 435223, 175641, 170811, 161624, 144882, 116883, 107938, 107874, 89058, 1768],
		  riskFactors: ['高血压', '抽烟', '肥胖', '高血糖', '高胆固醇', '水果饮食偏少', '饮食含盐量高', '空气污染（室内和室外）', '低体力活动', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [722666, 559068, 443763, 326529, 319257, 174256, 168051, 167959, 67965, 64921, 1768] },
		 {id: 23,
		  name: "蒲隆地",
		  lifeExpectancy: 61.58,
		  demographics: [3785408, 2623579, 2004917, 1466422, 701174, 487477, 322819, 105870, 32911],
		  majorCauses: ['结核', '心血管疾病', '疟疾', '新生儿疾病', '下呼吸道感染', '腹泻病', '癌症', '消化系统疾病', 'HIV爱滋病', '营养不足', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [9099, 9011, 8659, 7482, 7407, 5397, 4711, 3412, 2620, 2603, 1],
		  diseaseNames: ['腹泻和常见传染病', '疟疾和被忽视的热带病', '新生儿疾病', '艾滋病毒/艾滋病与结核病', '其他非传染性疾病', '营养不足', '心血管疾病', '癌症', '意外伤害', '糖尿病，血液和内分泌疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1763666, 679542, 674414, 626305, 406552, 266914, 246428, 161672, 160437, 152196, 22],
		  riskFactors: ['浪费孩子', '空气污染（室内和室外）', '不安全的水源', '不安全的卫生', '高血糖', '高血压', '儿童发育迟缓', '儿童发育不良', '抽烟', '水果饮食偏少', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [610582, 323545, 313197, 240297, 154991, 152765, 145961, 133758, 91457, 55690, 22] },
		 {id: 24,
		  name: "柬埔寨",
		  lifeExpectancy: 69.82,
		  demographics: [3522160, 3065792, 3101389, 2840783, 1393829, 1350228, 783099, 334192, 95070],
		  majorCauses: ['心血管疾病', '癌症', '消化系统疾病', '下呼吸道感染', '肝病', '呼吸疾病', '新生儿疾病', '道路伤害', '结核', '糖尿病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [24913, 12663, 11446, 9866, 9018, 4429, 4094, 3981, 2998, 2756, 0],
		  diseaseNames: ['腹泻和常见传染病', '心血管疾病', '新生儿疾病', '消化系统疾病', '意外伤害', '癌症', '其他非传染性疾病', '肝病', '肌肉骨骼疾病', '糖尿病，血液和内分泌疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [721621, 585245, 411142, 364324, 360494, 352544, 302834, 275523, 252164, 243279, 0],
		  riskFactors: ['空气污染（室内和室外）', '高血糖', '抽烟', '高血压', '浪费孩子', '水果饮食偏少', '肥胖', '高胆固醇', '缺铁', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [397320, 362958, 344974, 277013, 190587, 155655, 138476, 122622, 112834, 98497, 0] },
		 {id: 25,
		  name: "喀麦隆",
		  lifeExpectancy: 59.29,
		  demographics: [7725327, 6005828, 4449460, 3290814, 2054202, 1239232, 710194, 323649, 77681],
		  majorCauses: ['HIV爱滋病', '心血管疾病', '疟疾', '下呼吸道感染', '癌症', '新生儿疾病', '腹泻病', '结核', '消化系统疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [22803, 22663, 22041, 16148, 14658, 13311, 12644, 8077, 7474, 5096, 175],
		  diseaseNames: ['腹泻和常见传染病', '疟疾和被忽视的热带病', '艾滋病毒/艾滋病与结核病', '新生儿疾病', '其他非传染性疾病', '心血管疾病', '糖尿病，血液和内分泌疾病', '癌症', '营养不足', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [2368903, 1813493, 1710349, 1262545, 629329, 618008, 525557, 445027, 407151, 397774, 3900],
		  riskFactors: ['浪费孩子', '不安全的水源', '空气污染（室内和室外）', '不安全的卫生', '高血压', '儿童发育不良', '肥胖', '高血糖', '缺铁', '非独家母乳喂养', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [951069, 787773, 595132, 577616, 384797, 349035, 336907, 335000, 196545, 181684, 3900] },
		 {id: 26,
		  name: "加拿大",
		  lifeExpectancy: 82.43,
		  demographics: [3960088, 3974074, 5110382, 5204909, 4797691, 5260069, 4598419, 2876627, 1628778],
		  majorCauses: ['癌症', '心血管疾病', '痴呆', '呼吸疾病', '消化系统疾病', '下呼吸道感染', '糖尿病', 'COVID-19，直到2020年5月27日', '肾脏疾病', '肝病', '自杀'],
		  majorDeaths: [86229, 80838, 25219, 16133, 11283, 9048, 6959, 6639, 6087, 4845, 4616],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '意外伤害', '呼吸疾病', '其他非传染性疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1683333, 1259054, 1089020, 735538, 692030, 563635, 421128, 407422, 385240, 280539, 90250],
		  riskFactors: ['抽烟', '肥胖', '高血糖', '高血压', '用药', '高胆固醇', '饮食含盐量高', '空气污染（室内和室外）', '水果饮食偏少', '饮食中蔬菜含量低', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [1164013, 882678, 772461, 676655, 327167, 324651, 177023, 159411, 127590, 99110, 90250] },
		 {id: 27,
		  name: "中非共和國",
		  lifeExpectancy: 53.28,
		  demographics: [1426413, 1237990, 809868, 493393, 336400, 228493, 135393, 60949, 16279],
		  majorCauses: ['心血管疾病', '结核', '腹泻病', 'HIV爱滋病', '下呼吸道感染', '新生儿疾病', '疟疾', '道路伤害', '癌症', '冲突', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [7278, 6728, 5983, 5319, 5021, 4770, 3849, 3495, 2695, 1879, 1],
		  diseaseNames: ['腹泻和常见传染病', '艾滋病毒/艾滋病与结核病', '新生儿疾病', '疟疾和被忽视的热带病', '其他非传染性疾病', '运输伤害', '心血管疾病', '其他传染病', '营养不足', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1079157, 873581, 436725, 335234, 229369, 223308, 209221, 166194, 163616, 111740, 21],
		  riskFactors: ['浪费孩子', '不安全的水源', '不安全的卫生', '空气污染（室内和室外）', '儿童发育不良', '高血糖', '高血压', '儿童发育迟缓', '非独家母乳喂养', '抽烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [535834, 377491, 290329, 249265, 190556, 155425, 134033, 121888, 93807, 87791, 21] },
		 {id: 28,
		  name: "乍得",
		  lifeExpectancy: 54.24,
		  demographics: [5340972, 3921214, 2679775, 1701718, 1040270, 634886, 404731, 174402, 48914],
		  majorCauses: ['腹泻病', '下呼吸道感染', '新生儿疾病', '心血管疾病', '疟疾', '结核', '癌症', 'HIV爱滋病', '营养不足', '脑膜炎', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [24903, 19421, 17167, 13094, 7679, 6649, 6620, 4926, 4336, 4232, 62],
		  diseaseNames: ['腹泻和常见传染病', '新生儿疾病', '艾滋病毒/艾滋病与结核病', '疟疾和被忽视的热带病', '营养不足', '其他非传染性疾病', '其他传染病', '心血管疾病', '意外伤害', '糖尿病，血液和内分泌疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [3324967, 1521033, 739523, 714037, 630767, 494126, 389858, 358655, 346981, 278749, 1378],
		  riskFactors: ['浪费孩子', '不安全的水源', '不安全的卫生', '空气污染（室内和室外）', '儿童发育不良', '儿童发育迟缓', '非独家母乳喂养', '缺铁', '高血压', '高血糖', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [2694326, 1652727, 1287466, 880045, 768811, 604902, 418815, 253170, 187689, 160699, 1378] },
		 {id: 29,
		  name: "智利",
		  lifeExpectancy: 80.18,
		  demographics: [2450918, 2505672, 3020205, 2878807, 2556775, 2328585, 1737346, 950339, 523388],
		  majorCauses: ['癌症', '心血管疾病', '痴呆', '消化系统疾病', '呼吸疾病', '肝病', '下呼吸道感染', '肾脏疾病', '糖尿病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [30116, 29906, 8340, 7955, 6141, 4980, 4588, 4225, 3331, 2281, 806],
		  diseaseNames: ['癌症', '肌肉骨骼疾病', '心血管疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '神经系统疾病', '其他非传染性疾病', '消化系统疾病', '意外伤害', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [614838, 545626, 526835, 355493, 276342, 266925, 226976, 218323, 201592, 155243, 12027],
		  riskFactors: ['肥胖', '高血糖', '高血压', '抽烟', '空气污染（室内和室外）', '高胆固醇', '饮食含盐量高', '水果饮食偏少', '用药', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [400583, 369036, 365753, 335786, 129290, 123346, 98530, 87272, 86161, 46336, 12027] },
		 {id: 30,
		  name: "中国",
		  lifeExpectancy: 76.91,
		  demographics: [171585833, 166513709, 192891037, 223506345, 223201182, 214623812, 148420591, 66894771, 26146412],
		  majorCauses: ['心血管疾病', '癌症', '呼吸疾病', '痴呆', '消化系统疾病', '道路伤害', '下呼吸道感染', '肾脏疾病', '肝病', '糖尿病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [4377972, 2606907, 1009685, 490210, 283662, 261802, 179390, 175891, 153769, 153185, 4638],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '呼吸疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '神经系统疾病', '意外伤害', '运输伤害', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [85319394, 63203596, 25138911, 23223150, 22139741, 20302946, 16758994, 16453012, 14994208, 14865833, 75805],
		  riskFactors: ['抽烟', '高血压', '饮食含盐量高', '空气污染（室内和室外）', '肥胖', '高血糖', '水果饮食偏少', '高胆固醇', '二手烟', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [51286559, 50724732, 38074126, 28361531, 25733491, 25669596, 18622122, 16998810, 9416153, 8365260, 75805] },
		 {id: 31,
		  name: "哥伦比亚",
		  lifeExpectancy: 77.29,
		  demographics: [7448799, 8231614, 8779218, 7667022, 6339173, 5445614, 3633308, 1882391, 912304],
		  majorCauses: ['心血管疾病', '癌症', '呼吸疾病', '杀人', '痴呆', '消化系统疾病', '肾脏疾病', '下呼吸道感染', '道路伤害', '糖尿病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [68023, 46576, 15303, 15053, 15050, 10847, 8502, 7851, 7437, 6155, 776],
		  diseaseNames: ['心血管疾病', '癌症', '人际暴力', '肌肉骨骼疾病', '神经系统疾病', '新生儿疾病', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '精神和物质使用障碍', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1258942, 1121602, 851013, 792895, 731688, 684779, 672924, 646324, 636887, 414242, 12593],
		  riskFactors: ['高血压', '肥胖', '高血糖', '抽烟', '高胆固醇', '空气污染（室内和室外）', '饮食含盐量高', '用药', '饮食中蔬菜含量低', '浪费孩子', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [824543, 729807, 553419, 521123, 301768, 295755, 201572, 177867, 169492, 113277, 12593] },
		 {id: 32,
		  name: "葛摩",
		  lifeExpectancy: 64.32,
		  demographics: [234784, 187246, 148281, 114000, 74321, 49408, 28300, 11291, 3260],
		  majorCauses: ['心血管疾病', '癌症', '下呼吸道感染', '结核', '新生儿疾病', '腹泻病', '消化系统疾病', '糖尿病', '呼吸疾病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [982, 565, 384, 305, 286, 272, 235, 151, 144, 113, 1],
		  diseaseNames: ['腹泻和常见传染病', '新生儿疾病', '心血管疾病', '癌症', '其他非传染性疾病', '艾滋病毒/艾滋病与结核病', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '其他传染病', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [58275, 29193, 22929, 16910, 15236, 11967, 10010, 9808, 9388, 8770, 21],
		  riskFactors: ['高血压', '高血糖', '空气污染（室内和室外）', '浪费孩子', '不安全的水源', '不安全的卫生', '肥胖', '抽烟', '水果饮食偏少', '儿童发育不良', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [15143, 14657, 13840, 13011, 10983, 8619, 7850, 5708, 5074, 4641, 21] },
		 {id: 33,
		  name: "刚果共和国",
		  lifeExpectancy: 64.57,
		  demographics: [1570520, 1217193, 848863, 672432, 520344, 312337, 156783, 66533, 15498],
		  majorCauses: ['心血管疾病', 'HIV爱滋病', '癌症', '下呼吸道感染', '结核', '疟疾', '腹泻病', '新生儿疾病', '消化系统疾病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [6527, 5571, 3275, 2308, 2279, 2244, 2107, 1717, 1615, 1229, 19],
		  diseaseNames: ['腹泻和常见传染病', '艾滋病毒/艾滋病与结核病', '新生儿疾病', '疟疾和被忽视的热带病', '心血管疾病', '其他非传染性疾病', '癌症', '运输伤害', '营养不足', '精神和物质使用障碍', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [325799, 322346, 171187, 167855, 162431, 107522, 100822, 78622, 73269, 70131, 426],
		  riskFactors: ['高血糖', '高血压', '浪费孩子', '不安全的水源', '空气污染（室内和室外）', '肥胖', '不安全的卫生', '儿童发育不良', '抽烟', '缺铁', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [124326, 112354, 106554, 95933, 90427, 86646, 71649, 50058, 49945, 41776, 426] },
		 {id: 34,
		  name: "哥斯达黎加",
		  lifeExpectancy: 80.28,
		  demographics: [708607, 724264, 833947, 812730, 638064, 598490, 403726, 219837, 107896],
		  majorCauses: ['心血管疾病', '癌症', '消化系统疾病', '痴呆', '呼吸疾病', '肾脏疾病', '肝病', '道路伤害', '下呼吸道感染', '杀人', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [6852, 5717, 1546, 1458, 1331, 1265, 840, 782, 521, 484, 10],
		  diseaseNames: ['癌症', '心血管疾病', '糖尿病，血液和内分泌疾病', '肌肉骨骼疾病', '精神和物质使用障碍', '神经系统疾病', '其他非传染性疾病', '消化系统疾病', '新生儿疾病', '运输伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [129752, 127974, 71800, 69245, 69175, 68520, 55612, 45180, 44686, 40129, 156],
		  riskFactors: ['高血压', '肥胖', '高血糖', '抽烟', '高胆固醇', '空气污染（室内和室外）', '用药', '饮食中蔬菜含量低', '饮食含盐量高', '水果饮食偏少', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [91847, 83330, 60423, 52627, 34589, 25963, 19624, 16119, 16042, 11088, 156] },
		 {id: 35,
		  name: "克罗地亚",
		  lifeExpectancy: 78.49,
		  demographics: [392834, 410760, 480216, 550013, 555343, 588949, 560899, 355380, 235905],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '消化系统疾病', '呼吸疾病', '肝病', '糖尿病', '肾脏疾病', '自杀', '下呼吸道感染', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [23426, 13549, 3369, 2105, 1890, 1095, 999, 829, 708, 562, 101],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '神经系统疾病', '意外伤害', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '消化系统疾病', '呼吸疾病', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [350896, 277822, 115566, 95306, 90347, 71504, 67555, 59045, 57095, 50719, 1305],
		  riskFactors: ['抽烟', '高血压', '高血糖', '肥胖', '高胆固醇', '空气污染（室内和室外）', '饮食含盐量高', '水果饮食偏少', '饮食中蔬菜含量低', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [236270, 221560, 184287, 175349, 111451, 66726, 54483, 41805, 33657, 32700, 1305] },
		 {id: 36,
		  name: "古巴",
		  lifeExpectancy: 78.8,
		  demographics: [1211133, 1264436, 1453162, 1486561, 1647810, 1926480, 1141744, 785066, 417092],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '下呼吸道感染', '呼吸疾病', '消化系统疾病', '肾脏疾病', '肝病', '自杀', '糖尿病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [37598, 26203, 6988, 5678, 4406, 3969, 2340, 1869, 1791, 1769, 82],
		  diseaseNames: ['心血管疾病', '癌症', '精神和物质使用障碍', '神经系统疾病', '肌肉骨骼疾病', '糖尿病，血液和内分泌疾病', '呼吸疾病', '消化系统疾病', '意外伤害', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [642754, 559920, 213593, 206468, 200596, 196844, 135526, 125201, 124433, 120958, 1157],
		  riskFactors: ['抽烟', '高血压', '肥胖', '高血糖', '高胆固醇', '空气污染（室内和室外）', '低体力活动', '二手烟', '水果饮食偏少', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [438389, 343228, 312365, 276017, 153908, 137799, 59008, 43727, 40328, 38862, 1157] },
		 {id: 37,
		  name: "賽普勒斯",
		  lifeExpectancy: 80.98,
		  demographics: [132700, 142584, 194044, 188609, 163509, 145402, 117232, 75969, 38524],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '呼吸疾病', '糖尿病', '消化系统疾病', '肾脏疾病', '下呼吸道感染', '道路伤害', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [2705, 2058, 483, 474, 401, 288, 256, 177, 152, 123, 17],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '精神和物质使用障碍', '神经系统疾病', '糖尿病，血液和内分泌疾病', '意外伤害', '呼吸疾病', '其他非传染性疾病', '运输伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [44787, 43465, 37224, 23489, 22987, 18671, 14397, 12683, 12131, 9314, 244],
		  riskFactors: ['抽烟', '高血糖', '高血压', '肥胖', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '饮食含盐量高', '饮食中蔬菜含量低', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [39657, 31547, 27432, 24115, 10889, 10563, 6165, 4247, 4166, 3965, 244] },
		 {id: 38,
		  name: "捷克",
		  lifeExpectancy: 79.38,
		  demographics: [1119008, 1033915, 1145980, 1510360, 1774233, 1333127, 1344888, 987327, 440375],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '消化系统疾病', '呼吸疾病', '下呼吸道感染', '糖尿病', '肝病', '自杀', '肾脏疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [48960, 28927, 7581, 4520, 3864, 3222, 2958, 2175, 1517, 1257, 317],
		  diseaseNames: ['心血管疾病', '癌症', '意外伤害', '肌肉骨骼疾病', '神经系统疾病', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '消化系统疾病', '呼吸疾病', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [767029, 588271, 299173, 266439, 218376, 192175, 161210, 142372, 138323, 117131, 4313],
		  riskFactors: ['抽烟', '高血压', '高血糖', '肥胖', '高胆固醇', '空气污染（室内和室外）', '饮食含盐量高', '水果饮食偏少', '饮食中蔬菜含量低', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [534077, 464396, 417162, 396780, 244021, 141737, 120526, 108619, 81237, 58791, 4313] },
		 {id: 39,
		  name: "刚果民主共和国",
		  lifeExpectancy: 60.68,
		  demographics: [28801093, 20234100, 13690339, 9435368, 6384869, 4195557, 2494965, 1224414, 329862],
		  majorCauses: ['心血管疾病', '疟疾', '下呼吸道感染', '新生儿疾病', '结核', '腹泻病', '癌症', '消化系统疾病', '道路伤害', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [83261, 81226, 58587, 53950, 53304, 36660, 33983, 24612, 20502, 16529, 67],
		  diseaseNames: ['腹泻和常见传染病', '疟疾和被忽视的热带病', '新生儿疾病', '艾滋病毒/艾滋病与结核病', '其他非传染性疾病', '心血管疾病', '营养不足', '意外伤害', '运输伤害', '其他传染病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [7863311, 7196932, 5077139, 4008675, 3345697, 2134794, 1817886, 1436816, 1426298, 1298704, 1403],
		  riskFactors: ['浪费孩子', '空气污染（室内和室外）', '不安全的水源', '不安全的卫生', '高血糖', '高血压', '儿童发育不良', '儿童发育迟缓', '肥胖', '缺铁', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [4257878, 2771806, 2150401, 1590217, 1570390, 1320957, 1304840, 963409, 585796, 579539, 1403] },
		 {id: 40,
		  name: "丹麦",
		  lifeExpectancy: 80.9,
		  demographics: [607866, 679998, 774991, 662575, 752091, 803945, 657184, 566946, 266281],
		  majorCauses: ['癌症', '心血管疾病', '痴呆', '呼吸疾病', '消化系统疾病', '下呼吸道感染', '糖尿病', '肾脏疾病', '肝病', '饮酒障碍', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [17404, 14525, 4477, 4319, 2530, 2377, 1294, 968, 947, 807, 563],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '呼吸疾病', '糖尿病，血液和内分泌疾病', '意外伤害', '其他非传染性疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [327456, 205301, 194924, 120546, 105512, 93110, 85962, 68094, 66681, 58050, 7430],
		  riskFactors: ['抽烟', '高血糖', '高血压', '肥胖', '高胆固醇', '空气污染（室内和室外）', '用药', '水果饮食偏少', '低体力活动', '饮食含盐量高', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [245839, 174984, 123682, 118127, 54793, 47590, 26013, 20933, 17766, 15494, 7430] },
		 {id: 41,
		  name: "厄瓜多尔",
		  lifeExpectancy: 77.01,
		  demographics: [3260635, 3116390, 2997435, 2540942, 2046448, 1546300, 1047152, 545637, 272718],
		  majorCauses: ['心血管疾病', '癌症', '消化系统疾病', '肾脏疾病', '下呼吸道感染', '痴呆', '道路伤害', '糖尿病', '肝病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [19679, 16097, 6155, 5739, 5149, 4971, 4465, 4389, 3457, 3387, 3203],
		  diseaseNames: ['心血管疾病', '癌症', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '神经系统疾病', '新生儿疾病', '意外伤害', '运输伤害', '肌肉骨骼疾病', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [396000, 384366, 300660, 261958, 248588, 242400, 240306, 240294, 239834, 234280, 53061],
		  riskFactors: ['肥胖', '高血糖', '高血压', '抽烟', '空气污染（室内和室外）', '高胆固醇', '浪费孩子', '用药', 'COVID-19，直到2020年5月27日', '饮食含盐量高', '饮食中蔬菜含量低'],
		  riskDALYs: [348663, 321389, 246503, 119257, 105392, 85569, 58040, 54693, 53061, 53036, 52491] },
		 {id: 42,
		  name: "埃及",
		  lifeExpectancy: 71.99,
		  demographics: [24622198, 17968738, 16473942, 14922068, 10574668, 7677870, 4957959, 2412411, 778221],
		  majorCauses: ['心血管疾病', '消化系统疾病', '癌症', '肝病', '道路伤害', '下呼吸道感染', '呼吸疾病', '糖尿病', '肾脏疾病', '痴呆', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [232675, 50101, 48024, 44692, 26946, 23097, 19990, 13836, 13115, 9852, 797],
		  diseaseNames: ['心血管疾病', '腹泻和常见传染病', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '肌肉骨骼疾病', '运输伤害', '消化系统疾病', '癌症', '精神和物质使用障碍', '神经系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [5910574, 2376177, 2004534, 1779497, 1734654, 1639386, 1638469, 1585928, 1499388, 1236761, 14855],
		  riskFactors: ['高血压', '肥胖', '高血糖', '空气污染（室内和室外）', '抽烟', '高胆固醇', '浪费孩子', '二手烟', '水果饮食偏少', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [3669121, 3557105, 3101643, 2195056, 2164638, 1845428, 916224, 664061, 658551, 595808, 14855] },
		 {id: 43,
		  name: "厄立特里亚",
		  lifeExpectancy: 66.32,
		  demographics: [978748, 830029, 574495, 446287, 274976, 167460, 127422, 75264, 22435],
		  majorCauses: ['心血管疾病', '结核', '癌症', '下呼吸道感染', '腹泻病', '新生儿疾病', '消化系统疾病', 'HIV爱滋病', '道路伤害', '营养不足', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [5211, 5072, 3968, 3737, 3723, 3013, 2104, 1521, 1287, 1147, 0],
		  diseaseNames: ['腹泻和常见传染病', '新生儿疾病', '艾滋病毒/艾滋病与结核病', '心血管疾病', '其他非传染性疾病', '营养不足', '癌症', '意外伤害', '消化系统疾病', '运输伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [480274, 297214, 197674, 154881, 152787, 147554, 146554, 98581, 91972, 79943, 0],
		  riskFactors: ['浪费孩子', '不安全的水源', '空气污染（室内和室外）', '不安全的卫生', '高血糖', '高血压', '儿童发育不良', '缺铁', '儿童发育迟缓', '抽烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [297140, 197758, 159271, 153111, 101300, 84060, 67867, 63384, 53520, 53356, 0] },
		 {id: 44,
		  name: "爱沙尼亚",
		  lifeExpectancy: 78.74,
		  demographics: [144409, 134136, 152005, 191747, 183573, 168320, 165824, 108288, 77347],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '消化系统疾病', '呼吸疾病', '肝病', '肾脏疾病', '自杀', '下呼吸道感染', '饮酒障碍', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [7744, 3461, 1118, 602, 293, 292, 268, 220, 217, 217, 65],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '意外伤害', '神经系统疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '消化系统疾病', '其他非传染性疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [113906, 70732, 31560, 31446, 30926, 22291, 22035, 20576, 14972, 11179, 829],
		  riskFactors: ['高血压', '肥胖', '抽烟', '高血糖', '高胆固醇', '饮食含盐量高', '水果饮食偏少', '用药', '空气污染（室内和室外）', '饮食中蔬菜含量低', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [80846, 58304, 56332, 48633, 37388, 15952, 12597, 12529, 9917, 7623, 829] },
		 {id: 45,
		  name: "埃塞俄比亚",
		  lifeExpectancy: 66.6,
		  demographics: [31533142, 26475407, 20669323, 13261792, 8719197, 5482039, 3520095, 1857863, 559868],
		  majorCauses: ['新生儿疾病', '心血管疾病', '腹泻病', '下呼吸道感染', '癌症', '结核', '消化系统疾病', 'HIV爱滋病', '肝病', '营养不足', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [68899, 58719, 58105, 47564, 42795, 35598, 27760, 17181, 16069, 12681, 6],
		  diseaseNames: ['腹泻和常见传染病', '新生儿疾病', '艾滋病毒/艾滋病与结核病', '其他非传染性疾病', '营养不足', '心血管疾病', '癌症', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [8628459, 6657770, 2988580, 1923960, 1872827, 1526604, 1414986, 1356684, 1343853, 1309199, 121],
		  riskFactors: ['浪费孩子', '不安全的水源', '不安全的卫生', '儿童发育不良', '空气污染（室内和室外）', '儿童发育迟缓', '高血糖', '高血压', '缺铁', '非独家母乳喂养', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [4547197, 3145313, 2543816, 2068085, 2019593, 1169571, 907469, 798529, 547656, 524032, 121] },
		 {id: 46,
		  name: "斐濟",
		  lifeExpectancy: 67.44,
		  demographics: [178430, 156385, 142025, 134490, 104486, 91193, 54810, 22779, 5357],
		  majorCauses: ['心血管疾病', '糖尿病', '癌症', '呼吸疾病', '下呼吸道感染', '肾脏疾病', '新生儿疾病', '消化系统疾病', '痴呆', '腹泻病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [2553, 1578, 739, 378, 312, 278, 175, 169, 133, 86, 0],
		  diseaseNames: ['糖尿病，血液和内分泌疾病', '心血管疾病', '腹泻和常见传染病', '癌症', '新生儿疾病', '其他非传染性疾病', '呼吸疾病', '意外伤害', '肌肉骨骼疾病', '精神和物质使用障碍', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [81934, 69931, 22502, 22019, 17626, 16262, 16096, 15187, 14204, 12061, 0],
		  riskFactors: ['高血糖', '肥胖', '高血压', '抽烟', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '饮食中蔬菜含量低', '二手烟', '饮食含盐量高', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [80830, 74137, 44313, 28763, 25566, 22452, 17909, 10712, 10082, 9252, 0] },
		 {id: 47,
		  name: "芬兰",
		  lifeExpectancy: 81.91,
		  demographics: [578800, 602758, 678649, 705213, 655323, 728975, 720693, 556209, 305539],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '消化系统疾病', '呼吸疾病', '肝病', '自杀', '下呼吸道感染', '帕金森综合症', '饮酒障碍', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [21359, 13089, 8546, 2416, 1784, 1178, 868, 713, 682, 598, 312],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '意外伤害', '糖尿病，血液和内分泌疾病', '消化系统疾病', '呼吸疾病', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [297803, 244327, 168915, 159341, 109069, 95183, 67129, 65492, 57755, 56824, 3999],
		  riskFactors: ['高血压', '高血糖', '肥胖', '抽烟', '高胆固醇', '水果饮食偏少', '用药', '饮食中蔬菜含量低', '饮食含盐量高', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [177418, 161016, 139500, 134558, 81929, 35314, 31633, 27778, 27062, 25187, 3999] },
		 {id: 48,
		  name: "法国",
		  lifeExpectancy: 82.66,
		  demographics: [7606630, 7857054, 7415448, 8007883, 8408482, 8600917, 7758713, 5456311, 4018291],
		  majorCauses: ['癌症', '心血管疾病', '痴呆', 'COVID-19，直到2020年5月27日', '消化系统疾病', '呼吸疾病', '下呼吸道感染', '自杀', '肝病', '糖尿病', '肾脏疾病'],
		  majorDeaths: [182241, 155683, 70567, 28530, 27350, 20917, 20732, 11067, 10621, 10579, 9279],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '意外伤害', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '消化系统疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [3380270, 2121253, 1815206, 1555743, 1407146, 999326, 828873, 686563, 601963, 532875, 357532],
		  riskFactors: ['抽烟', '高血压', '高血糖', '肥胖', '高胆固醇', 'COVID-19，直到2020年5月27日', '空气污染（室内和室外）', '水果饮食偏少', '用药', '饮食含盐量高', '低体力活动'],
		  riskDALYs: [1910863, 1144792, 1069097, 1035904, 529536, 357532, 346605, 266385, 261196, 186249, 167243] },
		 {id: 49,
		  name: "加蓬",
		  lifeExpectancy: 66.47,
		  demographics: [586583, 410229, 369653, 340542, 222608, 126869, 68865, 35920, 11309],
		  majorCauses: ['心血管疾病', '癌症', '下呼吸道感染', '疟疾', 'HIV爱滋病', '新生儿疾病', '消化系统疾病', '结核', '糖尿病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [2230, 1240, 756, 705, 644, 630, 601, 569, 447, 435, 14],
		  diseaseNames: ['腹泻和常见传染病', '艾滋病毒/艾滋病与结核病', '新生儿疾病', '疟疾和被忽视的热带病', '心血管疾病', '其他非传染性疾病', '癌症', '糖尿病，血液和内分泌疾病', '运输伤害', '精神和物质使用障碍', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [81025, 76009, 63650, 53830, 50948, 36479, 34988, 30639, 28574, 25521, 287],
		  riskFactors: ['高血糖', '高血压', '肥胖', '空气污染（室内和室外）', '抽烟', '缺铁', '浪费孩子', '不安全的水源', '不安全的卫生', '高胆固醇', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [45650, 35609, 33446, 22861, 20977, 16066, 13877, 13686, 9638, 9322, 287] },
		 {id: 50,
		  name: "冈比亚",
		  lifeExpectancy: 62.05,
		  demographics: [744980, 541297, 417652, 271437, 168487, 111373, 57178, 29296, 5996],
		  majorCauses: ['心血管疾病', '下呼吸道感染', '新生儿疾病', '癌症', 'HIV爱滋病', '腹泻病', '结核', '消化系统疾病', '呼吸疾病', '产妇疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [2686, 1235, 1216, 1090, 883, 616, 604, 564, 402, 312, 1],
		  diseaseNames: ['腹泻和常见传染病', '新生儿疾病', '其他非传染性疾病', '心血管疾病', '艾滋病毒/艾滋病与结核病', '营养不足', '癌症', '糖尿病，血液和内分泌疾病', '意外伤害', '精神和物质使用障碍', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [158130, 117340, 74485, 64688, 63678, 49673, 33379, 28846, 28696, 27958, 22],
		  riskFactors: ['浪费孩子', '空气污染（室内和室外）', '高血压', '不安全的水源', '缺铁', '高血糖', '肥胖', '不安全的卫生', '儿童发育不良', '抽烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [55905, 47203, 43352, 33016, 32534, 30844, 25630, 24125, 21488, 21141, 22] },
		 {id: 51,
		  name: "格鲁吉亚",
		  lifeExpectancy: 73.77,
		  demographics: [555503, 462513, 517237, 565027, 516086, 532797, 450191, 245487, 151920],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '消化系统疾病', '呼吸疾病', '肝病', '糖尿病', '肾脏疾病', '下呼吸道感染', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [29989, 7926, 2291, 1938, 1776, 1381, 1210, 785, 767, 724, 12],
		  diseaseNames: ['心血管疾病', '癌症', '糖尿病，血液和内分泌疾病', '神经系统疾病', '意外伤害', '肌肉骨骼疾病', '消化系统疾病', '精神和物质使用障碍', '呼吸疾病', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [492777, 199176, 77350, 71942, 71878, 66363, 61436, 52174, 50743, 49258, 167],
		  riskFactors: ['高血压', '高血糖', '肥胖', '抽烟', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '饮食含盐量高', '饮食中蔬菜含量低', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [330197, 249730, 207106, 181728, 112711, 96544, 85246, 73731, 53296, 37918, 167] },
		 {id: 52,
		  name: "德国",
		  lifeExpectancy: 81.33,
		  demographics: [7726915, 7948424, 9421661, 10770439, 10400203, 13574883, 10347526, 7589596, 5737398],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '呼吸疾病', '消化系统疾病', '肾脏疾病', '下呼吸道感染', '肝病', '糖尿病', '帕金森综合症', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [356362, 252763, 83782, 46375, 44735, 26754, 25237, 19558, 19133, 12716, 8349],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '呼吸疾病', '意外伤害', '消化系统疾病', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [4855900, 4820928, 2911225, 2149784, 1683775, 1498390, 1240818, 1133138, 1077631, 979500, 103590],
		  riskFactors: ['抽烟', '高血压', '高血糖', '肥胖', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '饮食含盐量高', '饮食中蔬菜含量低', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [3414722, 2775807, 2418682, 2199578, 1294183, 787908, 609964, 445019, 404628, 379320, 103590] },
		 {id: 53,
		  name: "加纳",
		  lifeExpectancy: 64.07,
		  demographics: [7954883, 6496468, 5300953, 4080533, 2958700, 2058206, 1030760, 439902, 97453],
		  majorCauses: ['心血管疾病', '疟疾', '下呼吸道感染', '癌症', '新生儿疾病', 'HIV爱滋病', '结核', '消化系统疾病', '腹泻病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [36615, 18757, 17761, 17559, 16951, 13878, 9142, 8541, 7309, 5381, 34],
		  diseaseNames: ['新生儿疾病', '腹泻和常见传染病', '疟疾和被忽视的热带病', '艾滋病毒/艾滋病与结核病', '心血管疾病', '其他非传染性疾病', '糖尿病，血液和内分泌疾病', '营养不足', '癌症', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1654622, 1394112, 1250172, 952830, 938267, 741457, 564721, 546793, 529975, 408703, 745],
		  riskFactors: ['高血压', '浪费孩子', '空气污染（室内和室外）', '高血糖', '肥胖', '不安全的水源', '缺铁', '不安全的卫生', '儿童发育不良', '抽烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [588032, 571389, 561136, 521296, 439123, 427879, 305486, 303853, 231330, 180575, 745] },
		 {id: 54,
		  name: "希腊",
		  lifeExpectancy: 82.24,
		  demographics: [910515, 1071214, 1068916, 1384511, 1584912, 1489576, 1243217, 940663, 779928],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '呼吸疾病', '下呼吸道感染', '肾脏疾病', '消化系统疾病', '帕金森综合症', '肝病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [50895, 31245, 11489, 6069, 4269, 3582, 3579, 1460, 1308, 1221, 173],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '呼吸疾病', '糖尿病，血液和内分泌疾病', '意外伤害', '其他非传染性疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [687099, 569885, 326957, 284049, 219619, 153164, 151809, 133281, 120023, 89730, 2100],
		  riskFactors: ['抽烟', '高血压', '高血糖', '肥胖', '高胆固醇', '空气污染（室内和室外）', '饮食含盐量高', '二手烟', '水果饮食偏少', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [560222, 357593, 314662, 288302, 216660, 129722, 59070, 56707, 53709, 52342, 2100] },
		 {id: 55,
		  name: "格林纳达",
		  lifeExpectancy: 72.4,
		  demographics: [18172, 16008, 18677, 17858, 12661, 12282, 9161, 4727, 2456],
		  majorCauses: ['心血管疾病', '癌症', '糖尿病', '下呼吸道感染', '痴呆', '肾脏疾病', '消化系统疾病', '呼吸疾病', '肝病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [411, 228, 95, 83, 51, 51, 41, 30, 19, 12, 0],
		  diseaseNames: ['心血管疾病', '癌症', '糖尿病，血液和内分泌疾病', '肌肉骨骼疾病', '神经系统疾病', '腹泻和常见传染病', '精神和物质使用障碍', '其他非传染性疾病', '意外伤害', '新生儿疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [7147, 4824, 3842, 1912, 1911, 1843, 1805, 1620, 1510, 1282, 0],
		  riskFactors: ['高血糖', '高血压', '肥胖', '抽烟', '空气污染（室内和室外）', '高胆固醇', '饮食中蔬菜含量低', '水果饮食偏少', '低体力活动', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [5685, 4337, 3932, 2146, 1782, 1177, 766, 746, 589, 399, 0] },
		 {id: 56,
		  name: "危地马拉",
		  lifeExpectancy: 74.3,
		  demographics: [4021938, 3865062, 3339524, 2460641, 1627996, 1016203, 695632, 366031, 188449],
		  majorCauses: ['心血管疾病', '癌症', '下呼吸道感染', '消化系统疾病', '杀人', '糖尿病', '肾脏疾病', '肝病', '新生儿疾病', '腹泻病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [15009, 11034, 9695, 7300, 6193, 5531, 5065, 4623, 3675, 2957, 63],
		  diseaseNames: ['腹泻和常见传染病', '新生儿疾病', '糖尿病，血液和内分泌疾病', '人际暴力', '心血管疾病', '癌症', '消化系统疾病', '其他非传染性疾病', '意外伤害', '精神和物质使用障碍', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [602755, 403822, 382601, 338262, 335440, 294204, 269396, 267082, 252017, 228858, 1128],
		  riskFactors: ['高血糖', '空气污染（室内和室外）', '肥胖', '浪费孩子', '高血压', '不安全的水源', '用药', '抽烟', '不安全的卫生', '高胆固醇', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [402592, 269293, 262556, 226714, 226087, 161136, 102818, 100650, 95949, 81342, 1128] },
		 {id: 57,
		  name: "几内亚",
		  lifeExpectancy: 61.6,
		  demographics: [3893217, 3131561, 2277961, 1403283, 864312, 600063, 394880, 166054, 39914],
		  majorCauses: ['心血管疾病', '下呼吸道感染', '疟疾', '新生儿疾病', '癌症', '结核', '腹泻病', '消化系统疾病', 'HIV爱滋病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [16151, 12033, 11355, 10012, 8125, 5917, 5287, 3131, 2989, 2898, 20],
		  diseaseNames: ['腹泻和常见传染病', '疟疾和被忽视的热带病', '新生儿疾病', '艾滋病毒/艾滋病与结核病', '心血管疾病', '其他非传染性疾病', '营养不足', '糖尿病，血液和内分泌疾病', '癌症', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1570992, 929025, 915842, 474268, 405634, 401375, 329709, 268882, 248388, 223100, 435],
		  riskFactors: ['浪费孩子', '空气污染（室内和室外）', '不安全的水源', '高血压', '不安全的卫生', '儿童发育不良', '高血糖', '儿童发育迟缓', '缺铁', '肥胖', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [731514, 509268, 290067, 232709, 216134, 197656, 172770, 143237, 135493, 114120, 435] },
		 {id: 58,
		  name: "圭亚那",
		  lifeExpectancy: 69.91,
		  demographics: [147517, 147825, 142736, 93866, 91021, 78183, 49260, 21780, 10587],
		  majorCauses: ['心血管疾病', '癌症', '糖尿病', '消化系统疾病', '下呼吸道感染', 'HIV爱滋病', '新生儿疾病', '自杀', '肾脏疾病', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [2034, 621, 425, 281, 248, 196, 194, 189, 181, 174, 11],
		  diseaseNames: ['心血管疾病', '糖尿病，血液和内分泌疾病', '新生儿疾病', '癌症', '精神和物质使用障碍', '腹泻和常见传染病', '艾滋病毒/艾滋病与结核病', '意外伤害', '其他非传染性疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [48488, 29028, 20211, 17630, 13647, 13225, 12727, 12670, 11948, 10822, 189],
		  riskFactors: ['高血糖', '高血压', '肥胖', '高胆固醇', '抽烟', '空气污染（室内和室外）', '水果饮食偏少', '饮食中蔬菜含量低', '浪费孩子', '缺铁', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [35463, 29423, 27805, 13961, 12513, 10968, 9387, 5708, 4171, 4063, 189] },
		 {id: 59,
		  name: "海地",
		  lifeExpectancy: 64.0,
		  demographics: [2503602, 2334380, 2030254, 1702688, 1062317, 774512, 506169, 253257, 95900],
		  majorCauses: ['心血管疾病', '癌症', '下呼吸道感染', '新生儿疾病', '道路伤害', '糖尿病', 'HIV爱滋病', '腹泻病', '消化系统疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [23978, 10065, 6003, 4793, 4487, 4003, 3850, 3703, 3619, 3134, 33],
		  diseaseNames: ['腹泻和常见传染病', '心血管疾病', '新生儿疾病', '其他非传染性疾病', '意外伤害', '艾滋病毒/艾滋病与结核病', '糖尿病，血液和内分泌疾病', '癌症', '运输伤害', '精神和物质使用障碍', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [734644, 612671, 458390, 384494, 368148, 340215, 313273, 291429, 265724, 171517, 613],
		  riskFactors: ['浪费孩子', '高血糖', '高血压', '空气污染（室内和室外）', '不安全的水源', '不安全的卫生', '肥胖', '高胆固醇', '抽烟', '缺铁', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [382608, 367485, 324753, 312815, 295182, 220161, 210943, 155160, 116590, 113575, 613] },
		 {id: 60,
		  name: "洪都拉斯",
		  lifeExpectancy: 75.27,
		  demographics: [2006000, 2073497, 1868035, 1435980, 1009908, 653401, 402303, 195289, 101701],
		  majorCauses: ['心血管疾病', '癌症', '消化系统疾病', '杀人', '痴呆', '肝病', '呼吸疾病', '新生儿疾病', '道路伤害', '腹泻病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [13117, 5431, 4449, 4154, 2408, 2388, 2056, 1464, 1294, 1229, 188],
		  diseaseNames: ['心血管疾病', '人际暴力', '新生儿疾病', '糖尿病，血液和内分泌疾病', '消化系统疾病', '癌症', '神经系统疾病', '腹泻和常见传染病', '其他非传染性疾病', '精神和物质使用障碍', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [282192, 228670, 180903, 164244, 156390, 152814, 133332, 128019, 126607, 118070, 3444],
		  riskFactors: ['高血压', '肥胖', '高血糖', '抽烟', '高胆固醇', '空气污染（室内和室外）', '不安全的水源', '水果饮食偏少', '饮食中蔬菜含量低', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [159975, 146377, 133796, 103459, 99629, 85602, 51514, 43189, 41993, 40037, 3444] },
		 {id: 61,
		  name: "匈牙利",
		  lifeExpectancy: 76.88,
		  demographics: [911982, 972734, 1176155, 1283490, 1579425, 1189378, 1322500, 822141, 426875],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '消化系统疾病', '呼吸疾病', '肝病', '糖尿病', '自杀', '肾脏疾病', '下呼吸道感染', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [57212, 32138, 7064, 5879, 5457, 3228, 2063, 2025, 1553, 1016, 505],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '意外伤害', '神经系统疾病', '消化系统疾病', '糖尿病，血液和内分泌疾病', '呼吸疾病', '精神和物质使用障碍', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [948587, 719728, 271875, 246768, 206846, 180409, 179146, 177834, 153606, 115640, 6850],
		  riskFactors: ['抽烟', '高血压', '肥胖', '高血糖', '高胆固醇', '空气污染（室内和室外）', '饮食含盐量高', '水果饮食偏少', '低体力活动', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [680552, 655486, 476990, 428625, 339453, 181526, 170125, 141183, 64658, 59660, 6850] },
		 {id: 62,
		  name: "冰岛",
		  lifeExpectancy: 82.99,
		  demographics: [43668, 44269, 48238, 46464, 42622, 42276, 36635, 22223, 12642],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '呼吸疾病', '下呼吸道感染', '消化系统疾病', '自杀', '帕金森综合症', '肾脏疾病', '糖尿病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [738, 652, 236, 114, 95, 65, 40, 39, 27, 22, 10],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '呼吸疾病', '意外伤害', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '腹泻和常见传染病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [12927, 10060, 9227, 7061, 6135, 3992, 3785, 3121, 3018, 1716, 139],
		  riskFactors: ['抽烟', '高血糖', '肥胖', '高血压', '高胆固醇', '用药', '空气污染（室内和室外）', '饮食中蔬菜含量低', '水果饮食偏少', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [7646, 6360, 6244, 5408, 3428, 1198, 1195, 1008, 1005, 925, 139] },
		 {id: 63,
		  name: "印度",
		  lifeExpectancy: 69.66,
		  demographics: [236731829, 252674336, 238481457, 212399683, 165881490, 125378954, 84296275, 37500685, 13073046],
		  majorCauses: ['心血管疾病', '呼吸疾病', '癌症', '腹泻病', '下呼吸道感染', '结核', '新生儿疾病', '消化系统疾病', '糖尿病', '肾脏疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [2632780, 1271687, 929500, 719083, 507364, 449794, 428672, 419545, 254555, 223821, 4337],
		  diseaseNames: ['心血管疾病', '腹泻和常见传染病', '新生儿疾病', '呼吸疾病', '糖尿病，血液和内分泌疾病', '癌症', '意外伤害', '其他非传染性疾病', '精神和物质使用障碍', '肌肉骨骼疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [64219262, 59105453, 46464098, 33125142, 26160476, 25772512, 23310913, 22563499, 22096435, 21348307, 79240],
		  riskFactors: ['空气污染（室内和室外）', '高血压', '高血糖', '抽烟', '浪费孩子', '不安全的水源', '高胆固醇', '肥胖', '缺铁', '水果饮食偏少', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [39210284, 37485408, 28068070, 23841107, 20642364, 19658345, 19264482, 17663196, 13222380, 11852430, 79240] },
		 {id: 64,
		  name: "印尼",
		  lifeExpectancy: 71.72,
		  demographics: [47977486, 46310084, 43068836, 41353654, 37293402, 28325635, 16650777, 7276648, 2369045],
		  majorCauses: ['心血管疾病', '癌症', '消化系统疾病', '糖尿病', '呼吸疾病', '结核', '肝病', '腹泻病', '痴呆', '下呼吸道感染', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [597995, 198835, 121488, 97005, 96316, 82219, 82145, 68636, 47869, 43764, 1418],
		  diseaseNames: ['心血管疾病', '腹泻和常见传染病', '糖尿病，血液和内分泌疾病', '癌症', '新生儿疾病', '肌肉骨骼疾病', '消化系统疾病', '艾滋病毒/艾滋病与结核病', '呼吸疾病', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [14436782, 6040809, 5756326, 5576287, 4267523, 4266640, 3709473, 3525877, 3510134, 3397022, 26400],
		  riskFactors: ['高血压', '高血糖', '抽烟', '肥胖', '空气污染（室内和室外）', '高胆固醇', '水果饮食偏少', '饮食含盐量高', '饮食中蔬菜含量低', '浪费孩子', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [10343485, 10011664, 6688501, 5556192, 4014640, 3476122, 3100077, 2859877, 2375858, 2098071, 26400] },
		 {id: 65,
		  name: "伊朗",
		  lifeExpectancy: 76.68,
		  demographics: [14377200, 11531256, 12885389, 16623647, 11185873, 8029753, 5126544, 2239919, 914312],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '道路伤害', '糖尿病', '呼吸疾病', '肾脏疾病', '消化系统疾病', '新生儿疾病', '下呼吸道感染', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [161330, 60600, 21435, 21124, 16033, 14948, 10163, 9907, 9553, 9315, 7508],
		  diseaseNames: ['心血管疾病', '精神和物质使用障碍', '肌肉骨骼疾病', '神经系统疾病', '癌症', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '新生儿疾病', '运输伤害', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [3176330, 1904817, 1783780, 1616255, 1592320, 1514747, 1355368, 1339143, 1271439, 924674, 136251],
		  riskFactors: ['高血压', '高血糖', '肥胖', '抽烟', '高胆固醇', '用药', '空气污染（室内和室外）', '低体力活动', '饮食含盐量高', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [1878213, 1713915, 1700004, 1081718, 1077120, 991126, 795938, 360228, 282413, 272788, 136251] },
		 {id: 66,
		  name: "伊拉克",
		  lifeExpectancy: 70.6,
		  demographics: [10485112, 8550850, 7013811, 5252557, 3814033, 2191874, 1261768, 552034, 187749],
		  majorCauses: ['心血管疾病', '冲突', '癌症', '新生儿疾病', '恐怖主义', '肾脏疾病', '糖尿病', '道路伤害', '下呼吸道感染', '痴呆', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [43072, 33240, 13780, 12278, 6476, 4706, 4281, 3773, 3628, 3600, 169],
		  diseaseNames: ['冲突与恐怖主义', '新生儿疾病', '心血管疾病', '糖尿病，血液和内分泌疾病', '腹泻和常见传染病', '其他非传染性疾病', '精神和物质使用障碍', '意外伤害', '肌肉骨骼疾病', '神经系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [2065047, 1276888, 1114616, 980591, 977639, 881383, 669242, 592465, 587218, 499474, 3560],
		  riskFactors: ['肥胖', '高血压', '高血糖', '高胆固醇', '空气污染（室内和室外）', '抽烟', '用药', '水果饮食偏少', '浪费孩子', '缺铁', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [728011, 713340, 686531, 653682, 367011, 365292, 285716, 232404, 175962, 155092, 3560] },
		 {id: 67,
		  name: "爱尔兰",
		  lifeExpectancy: 82.3,
		  demographics: [683362, 653400, 559110, 710607, 747666, 587995, 473864, 314560, 151934],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '呼吸疾病', 'COVID-19，直到2020年5月27日', '下呼吸道感染', '消化系统疾病', '肾脏疾病', '自杀', '糖尿病', '肝病'],
		  majorDeaths: [9681, 9581, 2698, 2226, 1615, 1372, 1145, 579, 453, 420, 393],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '精神和物质使用障碍', '神经系统疾病', '呼吸疾病', '其他非传染性疾病', '糖尿病，血液和内分泌疾病', '意外伤害', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [189194, 145789, 126929, 99180, 95089, 61214, 54913, 51616, 50239, 32460, 23153],
		  riskFactors: ['抽烟', '高血糖', '高血压', '肥胖', '高胆固醇', '空气污染（室内和室外）', 'COVID-19，直到2020年5月27日', '用药', '水果饮食偏少', '饮食含盐量高', '低体力活动'],
		  riskDALYs: [132906, 99314, 90195, 83764, 45699, 24227, 23153, 22113, 15034, 14695, 13727] },
		 {id: 68,
		  name: "以色列",
		  lifeExpectancy: 82.97,
		  demographics: [1654530, 1377821, 1178880, 1117905, 1019070, 779142, 702437, 430872, 258715],
		  majorCauses: ['癌症', '心血管疾病', '痴呆', '下呼吸道感染', '肾脏疾病', '糖尿病', '呼吸疾病', '消化系统疾病', '肝病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [12966, 11849, 4658, 2276, 2242, 2141, 1812, 1808, 707, 632, 281],
		  diseaseNames: ['癌症', '肌肉骨骼疾病', '心血管疾病', '神经系统疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '意外伤害', '呼吸疾病', '新生儿疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [253956, 211092, 175059, 151116, 143230, 134764, 98294, 80106, 63869, 51274, 3978],
		  riskFactors: ['高血糖', '抽烟', '肥胖', '高血压', '空气污染（室内和室外）', '高胆固醇', '用药', '饮食含盐量高', '低体力活动', '水果饮食偏少', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [167092, 158896, 121800, 113120, 52609, 45088, 19532, 17738, 16242, 14827, 3978] },
		 {id: 69,
		  name: "意大利",
		  lifeExpectancy: 83.51,
		  demographics: [5103576, 5740332, 6135226, 7100743, 9225165, 9453168, 7391126, 5935048, 4465708],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', 'COVID-19，直到2020年5月27日', '呼吸疾病', '消化系统疾病', '糖尿病', '肾脏疾病', '下呼吸道感染', '肝病', '帕金森综合症'],
		  majorDeaths: [216585, 180577, 73339, 32955, 29044, 26403, 18551, 14292, 13167, 11695, 7557],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '意外伤害', '消化系统疾病', '其他非传染性疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [3227357, 2648270, 1971740, 1748118, 1191659, 1020109, 703647, 597865, 593953, 578073, 402295],
		  riskFactors: ['抽烟', '高血糖', '高血压', '肥胖', '高胆固醇', '空气污染（室内和室外）', 'COVID-19，直到2020年5月27日', '用药', '饮食含盐量高', '低体力活动', '水果饮食偏少'],
		  riskDALYs: [1879616, 1702367, 1518935, 1310480, 648326, 522561, 402295, 271922, 267823, 220006, 207156] },
		 {id: 70,
		  name: "牙买加",
		  lifeExpectancy: 74.47,
		  demographics: [465506, 474181, 517860, 435865, 357187, 315232, 206614, 116152, 59679],
		  majorCauses: ['心血管疾病', '癌症', '糖尿病', '痴呆', '杀人', '肾脏疾病', '呼吸疾病', '消化系统疾病', '下呼吸道感染', 'HIV爱滋病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [6279, 3975, 2516, 1253, 887, 810, 695, 504, 503, 440, 9],
		  diseaseNames: ['心血管疾病', '糖尿病，血液和内分泌疾病', '癌症', '新生儿疾病', '人际暴力', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '其他非传染性疾病', '腹泻和常见传染病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [116834, 107775, 96171, 48412, 48126, 45159, 45023, 44712, 37202, 29423, 141],
		  riskFactors: ['高血糖', '肥胖', '高血压', '抽烟', '空气污染（室内和室外）', '高胆固醇', '水果饮食偏少', '饮食中蔬菜含量低', '缺铁', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [121104, 90114, 75774, 55231, 29649, 20221, 16755, 10866, 10335, 9483, 141] },
		 {id: 71,
		  name: "日本",
		  lifeExpectancy: 84.63,
		  demographics: [10363426, 11337747, 12268082, 14762678, 18753747, 16223340, 16318424, 15814619, 11018236],
		  majorCauses: ['癌症', '心血管疾病', '痴呆', '下呼吸道感染', '消化系统疾病', '呼吸疾病', '肾脏疾病', '自杀', '肝病', '帕金森综合症', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [414698, 368091, 198556, 109534, 56334, 53739, 35709, 28819, 25352, 15613, 858],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '神经系统疾病', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '意外伤害', '呼吸疾病', '其他非传染性疾病', '腹泻和常见传染病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [6647076, 5124426, 4181686, 3088970, 2174030, 2146019, 2122420, 1348675, 1284802, 1131219, 10052],
		  riskFactors: ['抽烟', '高血压', '高血糖', '肥胖', '饮食含盐量高', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '低体力活动', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [4211397, 3003185, 2241447, 1385128, 1315624, 987828, 839089, 819971, 423681, 412535, 10052] },
		 {id: 72,
		  name: "约旦",
		  lifeExpectancy: 74.53,
		  demographics: [2257019, 2159817, 1780641, 1468830, 1117097, 720652, 348029, 187481, 62131],
		  majorCauses: ['心血管疾病', '癌症', '新生儿疾病', '糖尿病', '痴呆', '肾脏疾病', '道路伤害', '下呼吸道感染', '消化系统疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [9018, 4502, 2023, 1516, 1299, 1281, 1110, 1014, 822, 730, 9],
		  diseaseNames: ['新生儿疾病', '心血管疾病', '其他非传染性疾病', '肌肉骨骼疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '癌症', '神经系统疾病', '运输伤害', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [231744, 205154, 200157, 171916, 170292, 144906, 129454, 128076, 79489, 77320, 180],
		  riskFactors: ['肥胖', '高血糖', '高血压', '抽烟', '用药', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '缺铁', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [186863, 157454, 137643, 109142, 70998, 70022, 67410, 40454, 32995, 28236, 180] },
		 {id: 73,
		  name: "哈萨克斯坦",
		  lifeExpectancy: 73.6,
		  demographics: [3854928, 2574607, 2706361, 2919045, 2254076, 2041467, 1366464, 538921, 295558],
		  majorCauses: ['心血管疾病', '癌症', '消化系统疾病', '肝病', '呼吸疾病', '痴呆', '自杀', '下呼吸道感染', '道路伤害', '新生儿疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [67339, 18400, 9115, 6849, 5615, 4481, 4263, 3624, 2767, 2047, 37],
		  diseaseNames: ['心血管疾病', '癌症', '意外伤害', '消化系统疾病', '其他非传染性疾病', '肌肉骨骼疾病', '精神和物质使用障碍', '神经系统疾病', '新生儿疾病', '糖尿病，血液和内分泌疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1423967, 499547, 385355, 337080, 287137, 261389, 253852, 251712, 250447, 228854, 620],
		  riskFactors: ['高血压', '肥胖', '抽烟', '高血糖', '高胆固醇', '水果饮食偏少', '空气污染（室内和室外）', '饮食含盐量高', '用药', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [790109, 644782, 598318, 495839, 469206, 263862, 212036, 208316, 129363, 105151, 620] },
		 {id: 74,
		  name: "肯尼亚",
		  lifeExpectancy: 66.7,
		  demographics: [13975897, 12493627, 9335457, 7280037, 4688651, 2676456, 1445979, 534812, 143051],
		  majorCauses: ['HIV爱滋病', '心血管疾病', '下呼吸道感染', '癌症', '腹泻病', '消化系统疾病', '新生儿疾病', '结核', '肝病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [48502, 35993, 23268, 21373, 20835, 18893, 16978, 14881, 10398, 6871, 52],
		  diseaseNames: ['腹泻和常见传染病', '艾滋病毒/艾滋病与结核病', '新生儿疾病', '心血管疾病', '其他非传染性疾病', '消化系统疾病', '癌症', '精神和物质使用障碍', '意外伤害', '神经系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [4434222, 2835626, 1764456, 930002, 926142, 685728, 669334, 637402, 541192, 506020, 1221],
		  riskFactors: ['浪费孩子', '不安全的水源', '空气污染（室内和室外）', '不安全的卫生', '高血糖', '高血压', '儿童发育不良', '肥胖', '抽烟', '儿童发育迟缓', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [1098902, 1013002, 819127, 765692, 621159, 595363, 539569, 373205, 315363, 263262, 1221] },
		 {id: 75,
		  name: "基里巴斯",
		  lifeExpectancy: 68.37,
		  demographics: [29279, 23045, 20596, 16281, 10981, 9781, 4873, 2205, 567],
		  majorCauses: ['心血管疾病', '糖尿病', '癌症', '呼吸疾病', '新生儿疾病', '结核', '消化系统疾病', '下呼吸道感染', '腹泻病', '自杀'],
		  majorDeaths: [270, 121, 93, 63, 57, 54, 44, 41, 33, 30],
		  diseaseNames: ['心血管疾病', '糖尿病，血液和内分泌疾病', '腹泻和常见传染病', '新生儿疾病', '其他非传染性疾病', '癌症', '呼吸疾病', '营养不足', '消化系统疾病', '自残'],
		  diseaseDALYs: [8817, 6413, 5760, 5386, 3723, 3039, 2700, 2106, 1748, 1689],
		  riskFactors: ['高血糖', '肥胖', '抽烟', '高血压', '空气污染（室内和室外）', '水果饮食偏少', '浪费孩子', '高胆固醇', '饮食中蔬菜含量低', '二手烟'],
		  riskDALYs: [9248, 7767, 6072, 4513, 3980, 2668, 2375, 2255, 1629, 1457] },
		 {id: 76,
		  name: "科威特",
		  lifeExpectancy: 75.49,
		  demographics: [615731, 509329, 462476, 916067, 936319, 514790, 197771, 44686, 9908],
		  majorCauses: ['心血管疾病', '癌症', '下呼吸道感染', '道路伤害', '痴呆', '消化系统疾病', '糖尿病', '肾脏疾病', '新生儿疾病', 'COVID-19，直到2020年5月27日', '呼吸疾病'],
		  majorDeaths: [3094, 1233, 573, 529, 324, 262, 217, 177, 173, 172, 166],
		  diseaseNames: ['心血管疾病', '肌肉骨骼疾病', '精神和物质使用障碍', '其他非传染性疾病', '神经系统疾病', '糖尿病，血液和内分泌疾病', '癌症', '运输伤害', '新生儿疾病', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [87091, 83602, 79495, 50897, 48788, 48403, 35261, 33603, 32252, 28823, 4153],
		  riskFactors: ['肥胖', '高血糖', '高血压', '抽烟', '高胆固醇', '用药', '空气污染（室内和室外）', '水果饮食偏少', '二手烟', '饮食含盐量高', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [83006, 51389, 51249, 42806, 39135, 35312, 31345, 16962, 10359, 9365, 4153] },
		 {id: 77,
		  name: "吉尔吉斯斯坦",
		  lifeExpectancy: 71.45,
		  demographics: [1513166, 1067795, 1104469, 977554, 673651, 576005, 340820, 103872, 58519],
		  majorCauses: ['心血管疾病', '癌症', '消化系统疾病', '肝病', '新生儿疾病', '呼吸疾病', '道路伤害', '下呼吸道感染', '痴呆', '自杀', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [16557, 3709, 2495, 2159, 1842, 1393, 884, 854, 824, 594, 16],
		  diseaseNames: ['心血管疾病', '新生儿疾病', '腹泻和常见传染病', '消化系统疾病', '癌症', '其他非传染性疾病', '意外伤害', '神经系统疾病', '精神和物质使用障碍', '肌肉骨骼疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [343877, 188505, 131432, 109728, 108236, 97255, 94677, 80365, 79860, 79635, 305],
		  riskFactors: ['高血压', '高血糖', '肥胖', '抽烟', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '饮食含盐量高', '缺铁', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [181555, 131066, 125338, 114377, 105735, 81421, 71032, 38858, 38235, 35181, 305] },
		 {id: 78,
		  name: "老挝",
		  lifeExpectancy: 67.92,
		  demographics: [1565148, 1456114, 1358326, 1054965, 749666, 509532, 304392, 130858, 40455],
		  majorCauses: ['心血管疾病', '癌症', '下呼吸道感染', '新生儿疾病', '呼吸疾病', '消化系统疾病', '道路伤害', '肝病', '腹泻病', '结核', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [13145, 4735, 3756, 3542, 2605, 2540, 1690, 1595, 1582, 1551, 0],
		  diseaseNames: ['腹泻和常见传染病', '心血管疾病', '新生儿疾病', '其他非传染性疾病', '癌症', '糖尿病，血液和内分泌疾病', '运输伤害', '呼吸疾病', '意外伤害', '肌肉骨骼疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [580354, 342443, 337627, 192109, 144731, 136833, 112789, 104873, 103883, 97528, 0],
		  riskFactors: ['空气污染（室内和室外）', '高血压', '浪费孩子', '高血糖', '抽烟', '肥胖', '不安全的水源', '高胆固醇', '二手烟', '水果饮食偏少', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [222829, 198600, 192745, 190221, 155967, 110542, 87473, 84290, 67491, 64915, 0] },
		 {id: 79,
		  name: "拉脫維亞",
		  lifeExpectancy: 75.29,
		  demographics: [209188, 184856, 205890, 262698, 256776, 269669, 243007, 165298, 109358],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '消化系统疾病', '自杀', '肝病', '呼吸疾病', '下呼吸道感染', '糖尿病', '饮酒障碍', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [15463, 5621, 1740, 998, 438, 434, 434, 379, 320, 294, 22],
		  diseaseNames: ['心血管疾病', '癌症', '意外伤害', '肌肉骨骼疾病', '神经系统疾病', '糖尿病，血液和内分泌疾病', '消化系统疾病', '精神和物质使用障碍', '其他非传染性疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [251875, 119164, 56908, 52574, 46943, 35877, 33911, 31469, 25380, 17912, 282],
		  riskFactors: ['高血压', '抽烟', '肥胖', '高血糖', '高胆固醇', '水果饮食偏少', '空气污染（室内和室外）', '饮食含盐量高', '低体力活动', '饮食中蔬菜含量低', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [155232, 109735, 105412, 89377, 81725, 38011, 31230, 29007, 19450, 18458, 282] },
		 {id: 80,
		  name: "黎巴嫩",
		  lifeExpectancy: 78.93,
		  demographics: [1183784, 1159529, 1186188, 1009919, 862619, 713217, 433181, 202860, 104411],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '糖尿病', '呼吸疾病', '消化系统疾病', '下呼吸道感染', '肾脏疾病', '道路伤害', '新生儿疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [14094, 7703, 1866, 1614, 1175, 833, 739, 594, 562, 557, 26],
		  diseaseNames: ['心血管疾病', '癌症', '精神和物质使用障碍', '肌肉骨骼疾病', '神经系统疾病', '其他非传染性疾病', '糖尿病，血液和内分泌疾病', '新生儿疾病', '呼吸疾病', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [277882, 211228, 156612, 131367, 117713, 93176, 89925, 82542, 73834, 60861, 440],
		  riskFactors: ['肥胖', '高血糖', '抽烟', '高血压', '用药', '空气污染（室内和室外）', '高胆固醇', '二手烟', '水果饮食偏少', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [210233, 191855, 176671, 168709, 98764, 78426, 69882, 33327, 32854, 29616, 440] },
		 {id: 81,
		  name: "莱索托",
		  lifeExpectancy: 54.33,
		  demographics: [476585, 430608, 395150, 322798, 202120, 139177, 94839, 47103, 16887],
		  majorCauses: ['HIV爱滋病', '心血管疾病', '结核', '癌症', '下呼吸道感染', '腹泻病', '糖尿病', '呼吸疾病', '新生儿疾病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [6331, 4007, 1932, 1798, 1573, 1225, 1114, 1046, 866, 803, 0],
		  diseaseNames: ['艾滋病毒/艾滋病与结核病', '腹泻和常见传染病', '心血管疾病', '新生儿疾病', '糖尿病，血液和内分泌疾病', '癌症', '运输伤害', '人际暴力', '呼吸疾病', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [699820, 221340, 98860, 82394, 66194, 53096, 49314, 47954, 41436, 36752, 0],
		  riskFactors: ['高血糖', '高血压', '空气污染（室内和室外）', '抽烟', '不安全的水源', '肥胖', '浪费孩子', '不安全的卫生', '水果饮食偏少', '儿童发育不良', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [90169, 65890, 64292, 61167, 60136, 57484, 50694, 45920, 26756, 19203, 0] },
		 {id: 82,
		  name: "利比里亚",
		  lifeExpectancy: 64.1,
		  demographics: [1400348, 1148335, 813535, 616321, 428711, 274075, 161538, 74640, 19871],
		  majorCauses: ['心血管疾病', '疟疾', '腹泻病', '新生儿疾病', '下呼吸道感染', '癌症', 'HIV爱滋病', '结核', '消化系统疾病', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [4414, 2810, 2503, 2442, 2317, 2118, 1840, 1495, 1232, 733, 26],
		  diseaseNames: ['腹泻和常见传染病', '疟疾和被忽视的热带病', '新生儿疾病', '艾滋病毒/艾滋病与结核病', '其他非传染性疾病', '心血管疾病', '营养不足', '糖尿病，血液和内分泌疾病', '癌症', '神经系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [488681, 293930, 236278, 153800, 136832, 115273, 90505, 80720, 63432, 59778, 547],
		  riskFactors: ['浪费孩子', '不安全的水源', '空气污染（室内和室外）', '不安全的卫生', '高血压', '儿童发育不良', '高血糖', '肥胖', '缺铁', '儿童发育迟缓', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [174555, 143231, 106021, 103123, 75963, 69593, 62246, 56236, 54699, 41929, 547] },
		 {id: 83,
		  name: "利比亚",
		  lifeExpectancy: 72.91,
		  demographics: [1291223, 1165300, 1102957, 1165502, 1020549, 574557, 269932, 135923, 51510],
		  majorCauses: ['心血管疾病', '癌症', '道路伤害', '冲突', '痴呆', '糖尿病', '呼吸疾病', '肾脏疾病', '消化系统疾病', '下呼吸道感染', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [13334, 5586, 1701, 1525, 1508, 1405, 1205, 1181, 878, 842, 3],
		  diseaseNames: ['心血管疾病', '运输伤害', '癌症', '冲突与恐怖主义', '肌肉骨骼疾病', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '神经系统疾病', '其他非传染性疾病', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [328433, 169622, 169432, 129405, 125922, 124647, 122767, 101482, 88270, 72970, 59],
		  riskFactors: ['肥胖', '高血压', '高血糖', '用药', '空气污染（室内和室外）', '抽烟', '高胆固醇', '水果饮食偏少', '二手烟', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [227177, 216077, 193983, 113035, 94613, 86942, 83501, 55052, 34933, 31056, 59] },
		 {id: 84,
		  name: "立陶宛",
		  lifeExpectancy: 75.93,
		  demographics: [296367, 248144, 341343, 336898, 366880, 428804, 342601, 228011, 170583],
		  majorCauses: ['心血管疾病', '癌症', '消化系统疾病', '痴呆', '自杀', '肝病', '呼吸疾病', '下呼吸道感染', '饮酒障碍', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [22251, 8075, 2024, 1997, 1033, 942, 782, 704, 359, 325, 65],
		  diseaseNames: ['心血管疾病', '癌症', '意外伤害', '肌肉骨骼疾病', '消化系统疾病', '神经系统疾病', '精神和物质使用障碍', '自残', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [345229, 175044, 92378, 76396, 65565, 65345, 50956, 40077, 40052, 37358, 824],
		  riskFactors: ['高血压', '抽烟', '肥胖', '高胆固醇', '高血糖', '水果饮食偏少', '饮食含盐量高', '空气污染（室内和室外）', '低体力活动', '饮食中蔬菜含量低', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [228930, 150010, 137263, 122854, 106816, 46928, 43265, 41843, 30148, 28203, 824] },
		 {id: 85,
		  name: "卢森堡",
		  lifeExpectancy: 82.25,
		  demographics: [65213, 66256, 84625, 95914, 93536, 88767, 60144, 36676, 24599],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '呼吸疾病', '消化系统疾病', '下呼吸道感染', 'COVID-19，直到2020年5月27日', '肝病', '肾脏疾病', '自杀', '糖尿病'],
		  majorDeaths: [1397, 1306, 440, 237, 227, 146, 110, 99, 85, 69, 64],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '意外伤害', '糖尿病，血液和内分泌疾病', '呼吸疾病', '其他非传染性疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [25726, 20631, 17093, 13528, 11354, 7441, 7178, 6819, 5929, 5905, 1533],
		  riskFactors: ['抽烟', '高血糖', '高血压', '肥胖', '高胆固醇', '空气污染（室内和室外）', '用药', '饮食含盐量高', '低体力活动', 'COVID-19，直到2020年5月27日', '饮食中蔬菜含量低'],
		  riskDALYs: [16915, 13697, 12220, 12139, 4597, 3660, 2657, 2172, 1544, 1533, 1412] },
		 {id: 86,
		  name: "馬其頓共和國",
		  lifeExpectancy: 75.8,
		  demographics: [228330, 236205, 290417, 326362, 297862, 282001, 240622, 129154, 52505],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '糖尿病', '呼吸疾病', '消化系统疾病', '肾脏疾病', '肝病', '自杀', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [10518, 4378, 848, 745, 534, 465, 309, 235, 191, 161, 116],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '糖尿病，血液和内分泌疾病', '意外伤害', '神经系统疾病', '精神和物质使用障碍', '其他非传染性疾病', '新生儿疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [190895, 108056, 46978, 44928, 42217, 37051, 31369, 24413, 23155, 22465, 1757],
		  riskFactors: ['高血压', '抽烟', '高血糖', '肥胖', '高胆固醇', '空气污染（室内和室外）', '饮食含盐量高', '水果饮食偏少', '二手烟', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [122094, 120255, 100479, 90355, 48532, 41927, 28845, 24530, 17622, 11510, 1757] },
		 {id: 87,
		  name: "马达加斯加",
		  lifeExpectancy: 67.04,
		  demographics: [7613806, 6226365, 4738874, 3267437, 2307708, 1484094, 874455, 343514, 113053],
		  majorCauses: ['心血管疾病', '腹泻病', '下呼吸道感染', '新生儿疾病', '癌症', '营养不足', '蛋白质能量营养不良', '呼吸疾病', '消化系统疾病', '疟疾', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [34526, 23378, 19854, 17584, 11740, 11669, 11453, 6402, 6017, 5799, 2],
		  diseaseNames: ['腹泻和常见传染病', '新生儿疾病', '营养不足', '心血管疾病', '其他非传染性疾病', '其他传染病', '疟疾和被忽视的热带病', '癌症', '意外伤害', '精神和物质使用障碍', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [3237251, 1641588, 1063864, 999114, 725114, 604605, 488825, 407861, 343230, 335685, 42],
		  riskFactors: ['浪费孩子', '不安全的水源', '不安全的卫生', '空气污染（室内和室外）', '高血压', '儿童发育不良', '儿童发育迟缓', '高血糖', '非独家母乳喂养', '水果饮食偏少', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [2307218, 1393535, 1116685, 947467, 593032, 568745, 523072, 348713, 273471, 213170, 42] },
		 {id: 88,
		  name: "马拉维",
		  lifeExpectancy: 64.26,
		  demographics: [5597505, 4605388, 3277849, 2195464, 1381160, 811930, 465000, 236664, 57788],
		  majorCauses: ['HIV爱滋病', '心血管疾病', '新生儿疾病', '癌症', '下呼吸道感染', '结核', '腹泻病', '疟疾', '消化系统疾病', '糖尿病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [21935, 15006, 11082, 10093, 9426, 7225, 7061, 6884, 5616, 2642, 4],
		  diseaseNames: ['艾滋病毒/艾滋病与结核病', '腹泻和常见传染病', '新生儿疾病', '疟疾和被忽视的热带病', '其他非传染性疾病', '心血管疾病', '癌症', '营养不足', '意外伤害', '糖尿病，血液和内分泌疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [2089369, 1833682, 1055239, 543959, 500729, 362649, 352625, 337524, 227082, 224552, 88],
		  riskFactors: ['浪费孩子', '空气污染（室内和室外）', '不安全的水源', '不安全的卫生', '高血压', '高血糖', '儿童发育不良', '缺铁', '肥胖', '抽烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [451940, 381809, 343107, 264097, 259254, 251827, 190735, 145811, 121910, 107264, 88] },
		 {id: 89,
		  name: "马来西亚",
		  lifeExpectancy: 76.16,
		  demographics: [5098216, 5185143, 5784427, 5525337, 3884381, 3080289, 2069406, 965368, 357222],
		  majorCauses: ['心血管疾病', '癌症', '下呼吸道感染', '消化系统疾病', '道路伤害', '痴呆', '呼吸疾病', '肾脏疾病', '肝病', '自杀', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [57288, 27057, 23692, 7061, 6946, 5887, 5770, 4731, 3082, 2281, 115],
		  diseaseNames: ['心血管疾病', '癌症', '糖尿病，血液和内分泌疾病', '腹泻和常见传染病', '精神和物质使用障碍', '肌肉骨骼疾病', '运输伤害', '其他非传染性疾病', '神经系统疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1352218, 699187, 489333, 485542, 473585, 444888, 418419, 359023, 356901, 242767, 2050],
		  riskFactors: ['高血压', '肥胖', '抽烟', '高血糖', '高胆固醇', '空气污染（室内和室外）', '饮食含盐量高', '水果饮食偏少', '饮食中蔬菜含量低', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [906745, 677680, 648420, 597790, 488883, 311272, 290148, 231226, 192134, 155544, 2050] },
		 {id: 90,
		  name: "马尔代夫",
		  lifeExpectancy: 78.92,
		  demographics: [73852, 60061, 140970, 127233, 62492, 35683, 17665, 8722, 4278],
		  majorCauses: ['心血管疾病', '癌症', '呼吸疾病', '肾脏疾病', '痴呆', '糖尿病', '道路伤害', '消化系统疾病', '新生儿疾病', '下呼吸道感染', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [422, 163, 102, 68, 68, 36, 33, 31, 28, 28, 5],
		  diseaseNames: ['心血管疾病', '肌肉骨骼疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '神经系统疾病', '其他非传染性疾病', '癌症', '新生儿疾病', '呼吸疾病', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [9055, 6687, 6304, 5798, 4981, 4681, 4195, 3731, 3720, 2289, 103],
		  riskFactors: ['高血压', '高血糖', '抽烟', '肥胖', '高胆固醇', '饮食含盐量高', '空气污染（室内和室外）', '缺铁', '二手烟', '水果饮食偏少', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [6038, 6025, 4954, 4660, 3006, 1777, 1700, 1432, 1253, 1218, 103] },
		 {id: 91,
		  name: "马里",
		  lifeExpectancy: 59.31,
		  demographics: [6628593, 4826908, 3089563, 2106937, 1431058, 810331, 488133, 225734, 50765],
		  majorCauses: ['新生儿疾病', '疟疾', '心血管疾病', '腹泻病', '下呼吸道感染', '癌症', '营养不足', '蛋白质能量营养不良', 'HIV爱滋病', '脑膜炎', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [26640, 25080, 18035, 15386, 11586, 10410, 6686, 6478, 5807, 5728, 70],
		  diseaseNames: ['新生儿疾病', '腹泻和常见传染病', '疟疾和被忽视的热带病', '营养不足', '其他非传染性疾病', '意外伤害', '心血管疾病', '其他传染病', '癌症', '艾滋病毒/艾滋病与结核病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [2363306, 2339166, 2198476, 960655, 917119, 505199, 497276, 461405, 345514, 340900, 1574],
		  riskFactors: ['浪费孩子', '不安全的水源', '不安全的卫生', '空气污染（室内和室外）', '儿童发育不良', '缺铁', '高血压', '高血糖', '儿童发育迟缓', '非独家母乳喂养', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [1632950, 852513, 654240, 636002, 421451, 335071, 240844, 216570, 200341, 175715, 1574] },
		 {id: 92,
		  name: "马耳他",
		  lifeExpectancy: 82.53,
		  demographics: [42898, 41262, 56840, 65191, 58253, 54234, 57908, 43005, 20785],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '下呼吸道感染', '呼吸疾病', '消化系统疾病', '糖尿病', '肾脏疾病', '帕金森综合症', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [1569, 1042, 331, 173, 172, 127, 117, 94, 54, 44, 6],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '意外伤害', '其他非传染性疾病', '呼吸疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [22705, 20259, 14018, 9810, 8075, 6672, 5952, 5074, 4816, 3573, 79],
		  riskFactors: ['高血糖', '抽烟', '高血压', '肥胖', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '低体力活动', '饮食含盐量高', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [17301, 15351, 13755, 12623, 6457, 4612, 2916, 2501, 2303, 1637, 79] },
		 {id: 93,
		  name: "毛里塔尼亚",
		  lifeExpectancy: 64.92,
		  demographics: [1282240, 981572, 770505, 601045, 405733, 256724, 144249, 64944, 18685],
		  majorCauses: ['心血管疾病', '癌症', '新生儿疾病', '下呼吸道感染', '腹泻病', '消化系统疾病', '道路伤害', '呼吸疾病', '痴呆', '结核', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [3924, 2309, 1998, 1895, 1490, 900, 674, 600, 559, 542, 9],
		  diseaseNames: ['腹泻和常见传染病', '新生儿疾病', '心血管疾病', '其他非传染性疾病', '营养不足', '癌症', '糖尿病，血液和内分泌疾病', '神经系统疾病', '精神和物质使用障碍', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [254069, 196903, 90510, 73989, 65102, 62379, 61153, 50133, 45926, 43310, 191],
		  riskFactors: ['浪费孩子', '不安全的水源', '空气污染（室内和室外）', '高血压', '不安全的卫生', '高血糖', '肥胖', '缺铁', '儿童发育不良', '水果饮食偏少', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [110162, 75285, 63864, 58706, 57685, 53308, 49965, 35213, 28530, 21226, 191] },
		 {id: 94,
		  name: "毛里求斯",
		  lifeExpectancy: 74.99,
		  demographics: [135453, 179059, 197068, 175844, 179920, 176623, 134345, 64819, 26539],
		  majorCauses: ['心血管疾病', '糖尿病', '癌症', '肾脏疾病', '呼吸疾病', '痴呆', '消化系统疾病', '下呼吸道感染', '肝病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [3310, 1729, 1394, 1070, 498, 454, 364, 307, 238, 165, 10],
		  diseaseNames: ['糖尿病，血液和内分泌疾病', '心血管疾病', '癌症', '肌肉骨骼疾病', '精神和物质使用障碍', '神经系统疾病', '呼吸疾病', '其他非传染性疾病', '消化系统疾病', '新生儿疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [79944, 70327, 35256, 26345, 20285, 20158, 16221, 15583, 12012, 11526, 158],
		  riskFactors: ['高血糖', '肥胖', '高血压', '抽烟', '高胆固醇', '空气污染（室内和室外）', '饮食含盐量高', '水果饮食偏少', '二手烟', '饮食中蔬菜含量低', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [102301, 63996, 57090, 32659, 22601, 21407, 18203, 17779, 11031, 8333, 158] },
		 {id: 95,
		  name: "墨西哥",
		  lifeExpectancy: 75.05,
		  demographics: [22245383, 22356958, 21623928, 18636625, 16343173, 12397493, 7946332, 4023962, 2001674],
		  majorCauses: ['心血管疾病', '癌症', '肾脏疾病', '糖尿病', '消化系统疾病', '杀人', '肝病', '呼吸疾病', '痴呆', '下呼吸道感染', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [161783, 97282, 65033, 64067, 62517, 43160, 40509, 34316, 32865, 21838, 8134],
		  diseaseNames: ['糖尿病，血液和内分泌疾病', '心血管疾病', '癌症', '其他非传染性疾病', '消化系统疾病', '神经系统疾病', '精神和物质使用障碍', '新生儿疾病', '人际暴力', '肌肉骨骼疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [4498557, 3180705, 2495963, 1967719, 1871651, 1793491, 1775959, 1617529, 1585274, 1544903, 135796],
		  riskFactors: ['高血糖', '肥胖', '高血压', '空气污染（室内和室外）', '抽烟', '高胆固醇', '用药', '水果饮食偏少', '饮食中蔬菜含量低', '浪费孩子', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [4873713, 3759331, 2371373, 1354813, 1278981, 923310, 644737, 513416, 413363, 360087, 135796] },
		 {id: 96,
		  name: "摩尔多瓦",
		  lifeExpectancy: 71.9,
		  demographics: [429166, 418687, 608197, 760165, 548003, 534327, 475100, 177807, 91806],
		  majorCauses: ['心血管疾病', '癌症', '消化系统疾病', '肝病', '痴呆', '下呼吸道感染', '呼吸疾病', '自杀', '饮酒障碍', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [23194, 6307, 3863, 3094, 1340, 949, 916, 650, 485, 442, 267],
		  diseaseNames: ['心血管疾病', '癌症', '消化系统疾病', '意外伤害', '肝病', '肌肉骨骼疾病', '神经系统疾病', '其他非传染性疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [426732, 173334, 133420, 101346, 92512, 83133, 65702, 59834, 58427, 56486, 4246],
		  riskFactors: ['高血压', '抽烟', '肥胖', '高血糖', '高胆固醇', '水果饮食偏少', '空气污染（室内和室外）', '饮食含盐量高', '饮食中蔬菜含量低', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [297875, 188075, 179833, 147746, 135227, 77300, 69090, 40474, 39500, 29548, 4246] },
		 {id: 97,
		  name: "蒙古国",
		  lifeExpectancy: 69.87,
		  demographics: [727414, 480990, 518734, 551697, 414977, 305432, 147247, 58191, 20484],
		  majorCauses: ['心血管疾病', '癌症', '消化系统疾病', '肝病', '新生儿疾病', '下呼吸道感染', '道路伤害', '自杀', '饮酒障碍', '结核', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [7770, 4811, 1835, 1374, 941, 660, 546, 525, 487, 367, 0],
		  diseaseNames: ['心血管疾病', '癌症', '新生儿疾病', '意外伤害', '消化系统疾病', '腹泻和常见传染病', '其他非传染性疾病', '精神和物质使用障碍', '肝病', '肌肉骨骼疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [198831, 129353, 97033, 84895, 66416, 57022, 55155, 44909, 43044, 41857, 0],
		  riskFactors: ['高血压', '肥胖', '抽烟', '高血糖', '空气污染（室内和室外）', '高胆固醇', '水果饮食偏少', '饮食中蔬菜含量低', '饮食含盐量高', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [132567, 95931, 89189, 66733, 60963, 54502, 54205, 32968, 30890, 17372, 0] },
		 {id: 98,
		  name: "蒙特內哥羅",
		  lifeExpectancy: 76.88,
		  demographics: [74487, 78919, 84827, 88916, 82984, 81320, 75907, 38922, 21706],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '糖尿病', '消化系统疾病', '肾脏疾病', '呼吸疾病', '自杀', '下呼吸道感染', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [3737, 1401, 354, 162, 156, 127, 86, 77, 68, 57, 9],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '意外伤害', '神经系统疾病', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '消化系统疾病', '其他非传染性疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [62760, 31982, 14414, 13327, 11507, 10931, 9243, 6119, 6077, 4768, 128],
		  riskFactors: ['抽烟', '高血压', '高血糖', '肥胖', '高胆固醇', '空气污染（室内和室外）', '饮食含盐量高', '二手烟', '水果饮食偏少', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [44250, 38418, 31099, 25922, 13968, 11166, 8611, 5067, 3646, 2982, 128] },
		 {id: 99,
		  name: "摩洛哥",
		  lifeExpectancy: 76.68,
		  demographics: [6750500, 6039210, 5923781, 5535929, 4352251, 3698794, 2589647, 1147171, 434483],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '糖尿病', '呼吸疾病', '道路伤害', '消化系统疾病', '下呼吸道感染', '新生儿疾病', '结核', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [115124, 24505, 9343, 8062, 7680, 7264, 5932, 5846, 5596, 4883, 202],
		  diseaseNames: ['心血管疾病', '糖尿病，血液和内分泌疾病', '肌肉骨骼疾病', '精神和物质使用障碍', '其他非传染性疾病', '癌症', '新生儿疾病', '神经系统疾病', '运输伤害', '腹泻和常见传染病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [2424457, 822462, 762679, 753673, 718496, 694746, 650262, 533369, 427572, 422025, 3522],
		  riskFactors: ['高血压', '高血糖', '肥胖', '抽烟', '空气污染（室内和室外）', '高胆固醇', '用药', '水果饮食偏少', '低体力活动', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [1611294, 1230615, 1207573, 567167, 556488, 542224, 288828, 236464, 232814, 201191, 3522] },
		 {id: 100,
		  name: "莫桑比克",
		  lifeExpectancy: 60.85,
		  demographics: [9513591, 7385303, 5101440, 3473273, 2201317, 1354583, 822822, 408321, 105393],
		  majorCauses: ['HIV爱滋病', '心血管疾病', '新生儿疾病', '结核', '疟疾', '癌症', '下呼吸道感染', '腹泻病', '消化系统疾病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [62135, 29833, 19375, 19234, 18423, 15826, 13895, 10689, 7118, 5078, 1],
		  diseaseNames: ['艾滋病毒/艾滋病与结核病', '腹泻和常见传染病', '新生儿疾病', '疟疾和被忽视的热带病', '其他非传染性疾病', '心血管疾病', '癌症', '营养不足', '意外伤害', '其他传染病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [4502707, 2510552, 1803582, 1444655, 942494, 816402, 533977, 526835, 446614, 439306, 21],
		  riskFactors: ['浪费孩子', '空气污染（室内和室外）', '高血压', '不安全的水源', '高血糖', '不安全的卫生', '抽烟', '儿童发育不良', '缺铁', '肥胖', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [645149, 639320, 587290, 562820, 476274, 431306, 322649, 292189, 289796, 232296, 21] },
		 {id: 101,
		  name: "缅甸",
		  lifeExpectancy: 67.13,
		  demographics: [9083867, 9994005, 9099437, 8049551, 7142439, 5431377, 3466856, 1354931, 422959],
		  majorCauses: ['心血管疾病', '癌症', '呼吸疾病', '消化系统疾病', '糖尿病', '肝病', '下呼吸道感染', '痴呆', '结核', '新生儿疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [77463, 60066, 55535, 28411, 27217, 23171, 22582, 14445, 13540, 13244, 6],
		  diseaseNames: ['心血管疾病', '癌症', '腹泻和常见传染病', '呼吸疾病', '新生儿疾病', '其他非传染性疾病', '糖尿病，血液和内分泌疾病', '消化系统疾病', '意外伤害', '肝病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1819145, 1696478, 1482854, 1458830, 1337542, 1201088, 1073858, 1048747, 837214, 815314, 114],
		  riskFactors: ['高血糖', '抽烟', '空气污染（室内和室外）', '高血压', '肥胖', '浪费孩子', '水果饮食偏少', '二手烟', '饮食含盐量高', '高胆固醇', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [1926019, 1681663, 1423169, 1219220, 753714, 522751, 500424, 376337, 349445, 347466, 114] },
		 {id: 102,
		  name: "纳米比亚",
		  lifeExpectancy: 63.71,
		  demographics: [647177, 516584, 469261, 345891, 230228, 146063, 83896, 40705, 14719],
		  majorCauses: ['HIV爱滋病', '心血管疾病', '癌症', '下呼吸道感染', '结核', '新生儿疾病', '腹泻病', '呼吸疾病', '消化系统疾病', '糖尿病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [3960, 3003, 1554, 1148, 869, 830, 813, 652, 595, 546, 0],
		  diseaseNames: ['艾滋病毒/艾滋病与结核病', '腹泻和常见传染病', '新生儿疾病', '心血管疾病', '糖尿病，血液和内分泌疾病', '癌症', '精神和物质使用障碍', '呼吸疾病', '运输伤害', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [288137, 136433, 77834, 60792, 43694, 43575, 32037, 27889, 27786, 27353, 0],
		  riskFactors: ['高血糖', '浪费孩子', '高血压', '不安全的水源', '空气污染（室内和室外）', '肥胖', '抽烟', '不安全的卫生', '水果饮食偏少', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [49467, 46679, 39352, 37616, 35866, 34031, 29709, 26189, 13623, 13050, 0] },
		 {id: 103,
		  name: "尼泊尔",
		  lifeExpectancy: 70.78,
		  demographics: [5479855, 6205791, 5664808, 3628380, 2958204, 2219564, 1443408, 791816, 216888],
		  majorCauses: ['心血管疾病', '呼吸疾病', '癌症', '腹泻病', '消化系统疾病', '下呼吸道感染', '新生儿疾病', '道路伤害', '肝病', '糖尿病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [49248, 23583, 18315, 10796, 9756, 9297, 8577, 6787, 5671, 5248, 4],
		  diseaseNames: ['腹泻和常见传染病', '心血管疾病', '新生儿疾病', '呼吸疾病', '肌肉骨骼疾病', '癌症', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '神经系统疾病', '运输伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1237825, 1131125, 930734, 657083, 546530, 492945, 492677, 450672, 440915, 371137, 74],
		  riskFactors: ['空气污染（室内和室外）', '高血压', '抽烟', '高血糖', '高胆固醇', '肥胖', '不安全的水源', '浪费孩子', '水果饮食偏少', '缺铁', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [783254, 589863, 585357, 475856, 323761, 308529, 253407, 217534, 215390, 157424, 74] },
		 {id: 104,
		  name: "荷兰",
		  lifeExpectancy: 82.28,
		  demographics: [1762690, 1973468, 2106722, 2075858, 2201959, 2520370, 2109482, 1526904, 819669],
		  majorCauses: ['癌症', '心血管疾病', '痴呆', '呼吸疾病', '下呼吸道感染', 'COVID-19，直到2020年5月27日', '消化系统疾病', '糖尿病', '肾脏疾病', '自杀', '帕金森综合症'],
		  majorDeaths: [51854, 40564, 14836, 10109, 6178, 5856, 5649, 2729, 2683, 2066, 1792],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '呼吸疾病', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '意外伤害', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [987417, 581670, 576427, 405596, 365519, 255064, 246098, 201647, 181251, 123640, 77616],
		  riskFactors: ['抽烟', '高血糖', '高血压', '肥胖', '高胆固醇', '空气污染（室内和室外）', 'COVID-19，直到2020年5月27日', '水果饮食偏少', '饮食中蔬菜含量低', '二手烟', '饮食含盐量高'],
		  riskDALYs: [694184, 425666, 349213, 329885, 146262, 137009, 77616, 66875, 48295, 45238, 45173] },
		 {id: 105,
		  name: "新西兰",
		  lifeExpectancy: 82.29,
		  demographics: [618147, 620994, 673857, 604748, 598468, 627307, 511426, 346232, 181883],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '呼吸疾病', '消化系统疾病', '肾脏疾病', '下呼吸道感染', '糖尿病', '自杀', '帕金森综合症', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [10898, 9838, 2975, 2143, 1000, 773, 728, 556, 537, 377, 21],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '精神和物质使用障碍', '意外伤害', '神经系统疾病', '呼吸疾病', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '运输伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [196818, 157168, 133048, 98229, 96355, 81421, 57606, 52563, 48073, 35614, 289],
		  riskFactors: ['抽烟', '肥胖', '高血压', '高血糖', '高胆固醇', '用药', '水果饮食偏少', '饮食含盐量高', '低体力活动', '空气污染（室内和室外）', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [106064, 93286, 82829, 71540, 40974, 18972, 17437, 17432, 15989, 13982, 289] },
		 {id: 106,
		  name: "尼加拉瓜",
		  lifeExpectancy: 74.48,
		  demographics: [1320595, 1235318, 1169503, 1039838, 735256, 494391, 331884, 144862, 73855],
		  majorCauses: ['心血管疾病', '癌症', '肾脏疾病', '消化系统疾病', '糖尿病', '痴呆', '肝病', '呼吸疾病', '下呼吸道感染', '新生儿疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [6033, 3289, 2292, 1579, 1231, 1173, 1127, 877, 849, 848, 35],
		  diseaseNames: ['糖尿病，血液和内分泌疾病', '心血管疾病', '新生儿疾病', '癌症', '其他非传染性疾病', '精神和物质使用障碍', '腹泻和常见传染病', '神经系统疾病', '肌肉骨骼疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [137933, 118992, 110320, 89278, 87937, 85514, 76249, 75694, 75208, 59384, 630],
		  riskFactors: ['高血糖', '高血压', '肥胖', '空气污染（室内和室外）', '抽烟', '高胆固醇', '水果饮食偏少', '用药', '浪费孩子', '饮食中蔬菜含量低', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [124835, 104480, 103370, 50125, 42168, 32233, 25596, 24331, 20732, 19942, 630] },
		 {id: 107,
		  name: "尼日尔",
		  lifeExpectancy: 62.42,
		  demographics: [8480646, 5660343, 3546877, 2165158, 1479270, 1019589, 621905, 282848, 54083],
		  majorCauses: ['疟疾', '腹泻病', '下呼吸道感染', '新生儿疾病', '心血管疾病', '癌症', '脑膜炎', '结核', '消化系统疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [30485, 21955, 19710, 16202, 13967, 8177, 7815, 5809, 4412, 3053, 63],
		  diseaseNames: ['腹泻和常见传染病', '疟疾和被忽视的热带病', '新生儿疾病', '其他非传染性疾病', '营养不足', '意外伤害', '心血管疾病', '艾滋病毒/艾滋病与结核病', '糖尿病，血液和内分泌疾病', '癌症', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [3596300, 2479474, 1471369, 640298, 508046, 424815, 402079, 394453, 357992, 262404, 1392],
		  riskFactors: ['浪费孩子', '不安全的水源', '不安全的卫生', '空气污染（室内和室外）', '儿童发育不良', '儿童发育迟缓', '非独家母乳喂养', '缺铁', '高血压', '高血糖', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [2391690, 1451900, 1142631, 955333, 727289, 600184, 312924, 235597, 219262, 186065, 1392] },
		 {id: 108,
		  name: "尼日利亚",
		  lifeExpectancy: 54.69,
		  demographics: [62691322, 46319357, 32244205, 23840172, 16454206, 10366004, 6059156, 2555573, 433608],
		  majorCauses: ['下呼吸道感染', '新生儿疾病', 'HIV爱滋病', '疟疾', '腹泻病', '心血管疾病', '癌症', '消化系统疾病', '结核', '脑膜炎', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [189930, 180355, 169103, 152240, 138359, 122519, 96555, 71076, 57219, 52948, 249],
		  diseaseNames: ['腹泻和常见传染病', '新生儿疾病', '疟疾和被忽视的热带病', '艾滋病毒/艾滋病与结核病', '其他非传染性疾病', '营养不足', '意外伤害', '癌症', '心血管疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [22428208, 16451503, 13621942, 8918085, 5304259, 5011258, 3191644, 3107214, 3006460, 2963064, 5630],
		  riskFactors: ['浪费孩子', '不安全的水源', '空气污染（室内和室外）', '不安全的卫生', '儿童发育迟缓', '儿童发育不良', '非独家母乳喂养', '缺铁', '高血压', '高血糖', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [17020469, 8920346, 7708156, 5675060, 4489373, 4065618, 2815935, 2442647, 1834799, 1307256, 5630] },
		 {id: 109,
		  name: "北朝鲜",
		  lifeExpectancy: 72.27,
		  demographics: [3415644, 3619103, 3930083, 3583278, 3864207, 3498467, 2008869, 1321013, 425493],
		  majorCauses: ['心血管疾病', '呼吸疾病', '癌症', '消化系统疾病', '痴呆', '道路伤害', '下呼吸道感染', '肝病', '肾脏疾病', '自杀'],
		  majorDeaths: [90238, 44378, 41553, 8515, 7394, 5744, 5689, 4657, 3639, 3309],
		  diseaseNames: ['心血管疾病', '癌症', '呼吸疾病', '肌肉骨骼疾病', '腹泻和常见传染病', '糖尿病，血液和内分泌疾病', '意外伤害', '精神和物质使用障碍', '运输伤害', '其他非传染性疾病'],
		  diseaseDALYs: [1972988, 1136274, 1044331, 469098, 446368, 429775, 384677, 369114, 349473, 338617],
		  riskFactors: ['高血压', '抽烟', '空气污染（室内和室外）', '高血糖', '水果饮食偏少', '饮食含盐量高', '高胆固醇', '二手烟', '肥胖', '用药'],
		  riskDALYs: [1163781, 976860, 936794, 613016, 457399, 425374, 368085, 261550, 242889, 149500] },
		 {id: 110,
		  name: "挪威",
		  lifeExpectancy: 82.4,
		  demographics: [616243, 643048, 724428, 727725, 730800, 701457, 581791, 427144, 226223],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '呼吸疾病', '下呼吸道感染', '消化系统疾病', '糖尿病', '肾脏疾病', '自杀', '帕金森综合症', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [12886, 11611, 4465, 2639, 1840, 1388, 591, 590, 583, 465, 235],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '意外伤害', '呼吸疾病', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [221284, 172270, 155719, 121986, 107914, 76659, 67981, 64332, 62429, 36676, 3177],
		  riskFactors: ['抽烟', '高血糖', '高血压', '肥胖', '高胆固醇', '用药', '空气污染（室内和室外）', '低体力活动', '饮食中蔬菜含量低', '饮食含盐量高', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [141475, 111526, 100285, 89227, 52550, 24230, 22253, 17531, 16074, 15654, 3177] },
		 {id: 111,
		  name: "阿曼",
		  lifeExpectancy: 77.86,
		  demographics: [819521, 514291, 1121755, 1363532, 647718, 301482, 134169, 51814, 20710],
		  majorCauses: ['心血管疾病', '道路伤害', '癌症', '糖尿病', '下呼吸道感染', '痴呆', '新生儿疾病', '肾脏疾病', '消化系统疾病', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [4128, 1950, 1277, 538, 404, 403, 397, 253, 246, 176, 37],
		  diseaseNames: ['心血管疾病', '运输伤害', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '肌肉骨骼疾病', '神经系统疾病', '新生儿疾病', '其他非传染性疾病', '癌症', '腹泻和常见传染病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [117912, 110700, 88899, 79017, 78480, 54880, 53231, 50870, 41049, 33166, 887],
		  riskFactors: ['肥胖', '高血压', '高血糖', '高胆固醇', '用药', '抽烟', '空气污染（室内和室外）', '饮食含盐量高', '饮食中蔬菜含量低', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [87985, 77564, 73162, 48535, 46122, 34355, 33033, 11511, 10596, 10342, 887] },
		 {id: 112,
		  name: "巴基斯坦",
		  lifeExpectancy: 67.27,
		  demographics: [52774521, 44914765, 39377474, 29843795, 20586127, 14690100, 8500213, 4464790, 1413532],
		  majorCauses: ['心血管疾病', '新生儿疾病', '癌症', '消化系统疾病', '呼吸疾病', '腹泻病', '下呼吸道感染', '道路伤害', '肝病', '结核', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [381421, 185098, 170987, 72647, 69969, 59787, 59440, 53009, 45501, 44150, 1225],
		  diseaseNames: ['新生儿疾病', '腹泻和常见传染病', '心血管疾病', '癌症', '其他非传染性疾病', '糖尿病，血液和内分泌疾病', '运输伤害', '消化系统疾病', '意外伤害', '精神和物质使用障碍', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [17719118, 9720916, 9486921, 5811824, 4382185, 3758170, 3457346, 3027349, 2997880, 2860291, 23742],
		  riskFactors: ['高血压', '空气污染（室内和室外）', '浪费孩子', '高血糖', '抽烟', '肥胖', '不安全的水源', '高胆固醇', '水果饮食偏少', '缺铁', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [5532401, 4903301, 4539357, 4506942, 3688735, 3414335, 3335793, 2999458, 2206292, 1817366, 23742] },
		 {id: 113,
		  name: "巴勒斯坦",
		  lifeExpectancy: 74.05,
		  demographics: [1349183, 1088552, 950260, 636206, 432598, 283953, 144571, 74627, 21472],
		  majorCauses: ['心血管疾病', '癌症', '新生儿疾病', '糖尿病', '痴呆', '肾脏疾病', '下呼吸道感染', '呼吸疾病', '消化系统疾病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [5327, 2265, 1014, 763, 690, 624, 515, 411, 371, 355, 5],
		  diseaseNames: ['心血管疾病', '新生儿疾病', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '其他非传染性疾病', '癌症', '肌肉骨骼疾病', '腹泻和常见传染病', '神经系统疾病', '冲突与恐怖主义', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [120854, 111822, 93873, 85527, 78395, 66839, 65093, 63404, 59321, 38914, 105],
		  riskFactors: ['高血糖', '肥胖', '高血压', '高胆固醇', '抽烟', '空气污染（室内和室外）', '用药', '水果饮食偏少', '饮食中蔬菜含量低', '缺铁', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [86431, 77642, 68379, 65832, 35706, 33555, 28138, 23336, 13917, 13248, 105] },
		 {id: 114,
		  name: "巴拿马",
		  lifeExpectancy: 78.51,
		  demographics: [771035, 720783, 669917, 611062, 547002, 420154, 271162, 151433, 83892],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '糖尿病', '肾脏疾病', '下呼吸道感染', '消化系统疾病', '呼吸疾病', '杀人', 'HIV爱滋病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [5246, 3519, 1291, 1068, 951, 897, 825, 767, 640, 526, 313],
		  diseaseNames: ['心血管疾病', '癌症', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '精神和物质使用障碍', '神经系统疾病', '肌肉骨骼疾病', '新生儿疾病', '腹泻和常见传染病', '人际暴力', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [96163, 84501, 76588, 58716, 53776, 52367, 51530, 51264, 51169, 36729, 4949],
		  riskFactors: ['高血糖', '肥胖', '高血压', '抽烟', '高胆固醇', '空气污染（室内和室外）', '浪费孩子', '水果饮食偏少', '饮食中蔬菜含量低', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [69997, 63877, 61938, 37342, 24272, 23091, 16591, 13138, 12850, 12570, 4949] },
		 {id: 115,
		  name: "巴拉圭",
		  lifeExpectancy: 74.25,
		  demographics: [1381066, 1337773, 1316292, 1082701, 703289, 541135, 391066, 203938, 87379],
		  majorCauses: ['心血管疾病', '癌症', '糖尿病', '肾脏疾病', '痴呆', '消化系统疾病', '道路伤害', '下呼吸道感染', '呼吸疾病', '杀人', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [9835, 5649, 2188, 1602, 1557, 1516, 1491, 1361, 1075, 845, 11],
		  diseaseNames: ['心血管疾病', '糖尿病，血液和内分泌疾病', '癌症', '精神和物质使用障碍', '肌肉骨骼疾病', '神经系统疾病', '腹泻和常见传染病', '其他非传染性疾病', '运输伤害', '新生儿疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [200872, 144522, 142533, 117408, 108992, 98834, 89711, 88327, 81498, 61604, 189],
		  riskFactors: ['高血糖', '肥胖', '高血压', '抽烟', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '饮食中蔬菜含量低', '缺铁', '饮食含盐量高', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [158929, 137710, 133881, 107531, 57416, 57294, 34245, 27128, 26824, 22666, 189] },
		 {id: 116,
		  name: "秘鲁",
		  lifeExpectancy: 76.74,
		  demographics: [5489704, 5224879, 5423768, 5068397, 4191544, 3185093, 2171756, 1190014, 565307],
		  majorCauses: ['癌症', '心血管疾病', '下呼吸道感染', '痴呆', '消化系统疾病', '呼吸疾病', '肝病', '肾脏疾病', '道路伤害', '糖尿病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [28513, 27720, 16638, 10195, 9227, 7492, 5562, 5287, 4577, 4300, 3788],
		  diseaseNames: ['癌症', '腹泻和常见传染病', '心血管疾病', '肌肉骨骼疾病', '新生儿疾病', '精神和物质使用障碍', '其他非传染性疾病', '意外伤害', '糖尿病，血液和内分泌疾病', '神经系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [677852, 608338, 554569, 481426, 479788, 470720, 444089, 407091, 402992, 401858, 61540],
		  riskFactors: ['肥胖', '高血糖', '高血压', '空气污染（室内和室外）', '抽烟', '高胆固醇', '缺铁', '浪费孩子', '用药', '水果饮食偏少', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [397073, 335162, 297615, 264551, 186595, 130609, 107063, 104592, 94360, 72302, 61540] },
		 {id: 117,
		  name: "菲律宾",
		  lifeExpectancy: 71.23,
		  demographics: [22137588, 21224868, 19346448, 15169948, 12087102, 9132653, 5640281, 2495455, 882279],
		  majorCauses: ['心血管疾病', '癌症', '下呼吸道感染', '肾脏疾病', '呼吸疾病', '结核', '消化系统疾病', '糖尿病', '新生儿疾病', '杀人', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [217552, 79280, 68013, 34051, 33061, 29322, 26513, 26049, 24722, 15891, 886],
		  diseaseNames: ['心血管疾病', '腹泻和常见传染病', '新生儿疾病', '癌症', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '肌肉骨骼疾病', '呼吸疾病', '精神和物质使用障碍', '艾滋病毒/艾滋病与结核病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [5629957, 3099601, 2529191, 2433421, 2353436, 1866603, 1757721, 1660479, 1272495, 1191208, 16673],
		  riskFactors: ['高血糖', '高血压', '抽烟', '肥胖', '空气污染（室内和室外）', '高胆固醇', '浪费孩子', '饮食含盐量高', '二手烟', '饮食中蔬菜含量低', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [3746813, 3404482, 2967393, 2483498, 2200537, 1467962, 1124433, 946863, 775342, 750053, 16673] },
		 {id: 118,
		  name: "波兰",
		  lifeExpectancy: 78.73,
		  demographics: [3812694, 3683606, 4614458, 6098806, 5397403, 4653080, 5155357, 2736204, 1736162],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '消化系统疾病', '呼吸疾病', '下呼吸道感染', '肝病', '自杀', '糖尿病', '饮酒障碍', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [168709, 109266, 28753, 16843, 11826, 11096, 7788, 6778, 6655, 4457, 1024],
		  diseaseNames: ['心血管疾病', '癌症', '意外伤害', '肌肉骨骼疾病', '神经系统疾病', '消化系统疾病', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '呼吸疾病', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [2771014, 2360949, 974998, 945960, 804552, 593513, 574896, 546687, 478036, 455361, 13890],
		  riskFactors: ['抽烟', '高血压', '肥胖', '高血糖', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '饮食含盐量高', '低体力活动', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [2063927, 1559349, 1413317, 1306415, 890803, 564674, 466544, 363580, 209552, 182665, 13890] },
		 {id: 119,
		  name: "葡萄牙",
		  lifeExpectancy: 82.05,
		  demographics: [856604, 1029022, 1076533, 1253640, 1587112, 1472388, 1282301, 997530, 671048],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '下呼吸道感染', '呼吸疾病', '消化系统疾病', '糖尿病', '肾脏疾病', '肝病', '自杀', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [36943, 29600, 10795, 7160, 6598, 5111, 3769, 3109, 2133, 1359, 1342],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '呼吸疾病', '其他非传染性疾病', '意外伤害', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [556228, 483288, 348277, 258666, 226388, 202807, 150373, 118395, 117492, 113988, 16768],
		  riskFactors: ['高血糖', '抽烟', '肥胖', '高血压', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '低体力活动', '饮食含盐量高', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [404257, 312988, 279203, 267234, 109389, 81137, 62114, 44482, 41270, 37113, 16768] },
		 {id: 120,
		  name: "波多黎各",
		  lifeExpectancy: 80.1,
		  demographics: [265199, 397823, 321336, 356603, 409046, 413780, 354578, 263573, 151466],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '糖尿病', '自然灾害', '肾脏疾病', '呼吸疾病', '下呼吸道感染', '消化系统疾病', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [8447, 6428, 3037, 2909, 2355, 1691, 1632, 1610, 1496, 953, 129],
		  diseaseNames: ['心血管疾病', '糖尿病，血液和内分泌疾病', '癌症', '神经系统疾病', '肌肉骨骼疾病', '精神和物质使用障碍', '其他非传染性疾病', '呼吸疾病', '人际暴力', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [138694, 137965, 124356, 74842, 70601, 63381, 47707, 44739, 43088, 40890, 1683],
		  riskFactors: ['高血糖', '肥胖', '高血压', '抽烟', '高胆固醇', '空气污染（室内和室外）', '用药', '水果饮食偏少', '饮食中蔬菜含量低', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [164852, 164445, 96268, 44280, 38035, 29022, 19794, 15811, 14987, 14416, 1683] },
		 {id: 121,
		  name: "卡塔尔",
		  lifeExpectancy: 80.23,
		  demographics: [268598, 230385, 719809, 819308, 462935, 238779, 74010, 14279, 3968],
		  majorCauses: ['心血管疾病', '癌症', '道路伤害', '糖尿病', '消化系统疾病', '自杀', '肾脏疾病', '肝病', '痴呆', '下呼吸道感染', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [918, 660, 574, 287, 159, 145, 115, 114, 95, 91, 28],
		  diseaseNames: ['肌肉骨骼疾病', '精神和物质使用障碍', '运输伤害', '糖尿病，血液和内分泌疾病', '神经系统疾病', '心血管疾病', '意外伤害', '其他非传染性疾病', '癌症', '新生儿疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [51741, 51335, 34814, 33636, 31118, 30167, 25396, 22744, 21724, 15324, 800],
		  riskFactors: ['肥胖', '用药', '高血糖', '高血压', '空气污染（室内和室外）', '抽烟', '高胆固醇', '饮食含盐量高', '二手烟', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [44342, 35001, 33964, 18908, 16441, 14310, 10265, 3899, 3836, 3090, 800] },
		 {id: 122,
		  name: "羅馬尼亞",
		  lifeExpectancy: 76.05,
		  demographics: [1939134, 2069083, 2174981, 2621141, 3076100, 2508724, 2559619, 1482916, 932860],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '消化系统疾病', '肝病', '呼吸疾病', '下呼吸道感染', '肾脏疾病', '自杀', '糖尿病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [144849, 51229, 14456, 14232, 10114, 7448, 6207, 3043, 2364, 2260, 1210],
		  diseaseNames: ['心血管疾病', '癌症', '意外伤害', '肌肉骨骼疾病', '消化系统疾病', '神经系统疾病', '精神和物质使用障碍', '肝病', '呼吸疾病', '糖尿病，血液和内分泌疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [2293802, 1195901, 511173, 502200, 452352, 412973, 283885, 274588, 264969, 257818, 16197],
		  riskFactors: ['高血压', '抽烟', '肥胖', '高胆固醇', '高血糖', '饮食含盐量高', '空气污染（室内和室外）', '水果饮食偏少', '低体力活动', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [1528585, 1142662, 972055, 625135, 616402, 354630, 337445, 314456, 148658, 139479, 16197] },
		 {id: 123,
		  name: "俄罗斯",
		  lifeExpectancy: 72.58,
		  demographics: [18561902, 14795855, 16599344, 24452747, 19983554, 19449736, 18094236, 8266872, 5668011],
		  majorCauses: ['心血管疾病', '癌症', '消化系统疾病', '痴呆', '肝病', '自杀', '呼吸疾病', '下呼吸道感染', '饮酒障碍', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [1000223, 291447, 94609, 84369, 50910, 43897, 38232, 35493, 28504, 24385, 3807],
		  diseaseNames: ['心血管疾病', '癌症', '意外伤害', '消化系统疾病', '神经系统疾病', '肌肉骨骼疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '自残', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [18699165, 7188475, 4457968, 3463448, 2949462, 2933286, 2337415, 2043512, 1947477, 1889160, 53680],
		  riskFactors: ['高血压', '抽烟', '肥胖', '高胆固醇', '高血糖', '水果饮食偏少', '空气污染（室内和室外）', '用药', '饮食含盐量高', '饮食中蔬菜含量低', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [10606447, 8613005, 7301942, 7040122, 5421036, 2729779, 2341390, 1971308, 1848572, 1705448, 53680] },
		 {id: 124,
		  name: "卢旺达",
		  lifeExpectancy: 69.02,
		  demographics: [3502850, 2837454, 2168420, 1758438, 1012265, 721197, 419030, 163562, 43720],
		  majorCauses: ['心血管疾病', '下呼吸道感染', '癌症', '新生儿疾病', '消化系统疾病', '结核', '腹泻病', '疟疾', 'HIV爱滋病', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [8125, 6441, 6308, 5923, 4856, 4564, 3896, 3052, 2963, 2668, 0],
		  diseaseNames: ['腹泻和常见传染病', '新生儿疾病', '艾滋病毒/艾滋病与结核病', '其他非传染性疾病', '疟疾和被忽视的热带病', '癌症', '心血管疾病', '营养不足', '消化系统疾病', '精神和物质使用障碍', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [879009, 571287, 382120, 331276, 226776, 204285, 197051, 185350, 180480, 167605, 0],
		  riskFactors: ['浪费孩子', '空气污染（室内和室外）', '不安全的水源', '不安全的卫生', '高血糖', '高血压', '抽烟', '儿童发育不良', '肥胖', '儿童发育迟缓', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [331524, 249137, 204666, 158329, 133769, 120221, 100333, 87317, 65917, 63712, 0] },
		 {id: 125,
		  name: "萨摩亚",
		  lifeExpectancy: 73.32,
		  demographics: [52139, 41307, 30670, 21842, 19683, 16090, 9521, 4405, 1436],
		  majorCauses: ['心血管疾病', '癌症', '糖尿病', '呼吸疾病', '肾脏疾病', '下呼吸道感染', '痴呆', '消化系统疾病', '新生儿疾病', '肝病'],
		  majorDeaths: [411, 118, 79, 64, 56, 53, 49, 46, 29, 23],
		  diseaseNames: ['心血管疾病', '糖尿病，血液和内分泌疾病', '腹泻和常见传染病', '癌症', '新生儿疾病', '呼吸疾病', '肌肉骨骼疾病', '其他非传染性疾病', '精神和物质使用障碍', '神经系统疾病'],
		  diseaseDALYs: [9472, 6698, 3935, 3305, 3090, 2883, 2803, 2705, 2396, 2140],
		  riskFactors: ['高血糖', '肥胖', '高血压', '抽烟', '空气污染（室内和室外）', '高胆固醇', '水果饮食偏少', '二手烟', '饮食中蔬菜含量低', '缺铁'],
		  riskDALYs: [7631, 6959, 5743, 5211, 3003, 2345, 1772, 1521, 1406, 758] },
		 {id: 126,
		  name: "沙特阿拉伯",
		  lifeExpectancy: 75.13,
		  demographics: [5937284, 4817472, 5457856, 6886975, 6162478, 3055997, 1307059, 476138, 167270],
		  majorCauses: ['心血管疾病', '道路伤害', '癌症', '肾脏疾病', '下呼吸道感染', '痴呆', '消化系统疾病', '呼吸疾病', '冲突', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [31569, 12039, 11843, 3818, 3505, 3371, 3109, 2665, 2589, 2461, 411],
		  diseaseNames: ['心血管疾病', '运输伤害', '肌肉骨骼疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '神经系统疾病', '意外伤害', '其他非传染性疾病', '癌症', '新生儿疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [888316, 650397, 637913, 629363, 484211, 464319, 451767, 390981, 379671, 314120, 9101],
		  riskFactors: ['肥胖', '高血糖', '高血压', '用药', '空气污染（室内和室外）', '高胆固醇', '抽烟', '水果饮食偏少', '饮食中蔬菜含量低', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [743801, 575708, 539857, 320040, 306553, 274329, 222709, 158156, 111219, 101175, 9101] },
		 {id: 127,
		  name: "塞内加尔",
		  lifeExpectancy: 67.94,
		  demographics: [4949217, 3743997, 2751091, 1988586, 1278344, 803327, 488093, 231925, 61781],
		  majorCauses: ['心血管疾病', '癌症', '新生儿疾病', '下呼吸道感染', '腹泻病', '结核', '消化系统疾病', '呼吸疾病', '糖尿病', '疟疾', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [14794, 8931, 7877, 7727, 7270, 5250, 3747, 2852, 2349, 2146, 37],
		  diseaseNames: ['腹泻和常见传染病', '新生儿疾病', '其他非传染性疾病', '心血管疾病', '艾滋病毒/艾滋病与结核病', '糖尿病，血液和内分泌疾病', '营养不足', '癌症', '意外伤害', '疟疾和被忽视的热带病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1228484, 760280, 387694, 358045, 289473, 277391, 264538, 248163, 210820, 206816, 785],
		  riskFactors: ['浪费孩子', '不安全的水源', '空气污染（室内和室外）', '不安全的卫生', '高血压', '高血糖', '缺铁', '肥胖', '儿童发育不良', '水果饮食偏少', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [437753, 350590, 319175, 261781, 239801, 227424, 178631, 155356, 155343, 87564, 785] },
		 {id: 128,
		  name: "塞尔维亚",
		  lifeExpectancy: 76.0,
		  demographics: [868805, 1010416, 1119463, 1216521, 1227265, 1120356, 1161341, 696223, 351838],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '消化系统疾病', '呼吸疾病', '糖尿病', '肾脏疾病', '自杀', '下呼吸道感染', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [67115, 26965, 6512, 4234, 4160, 3445, 2386, 1601, 1512, 1304, 239],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '神经系统疾病', '糖尿病，血液和内分泌疾病', '意外伤害', '精神和物质使用障碍', '呼吸疾病', '消化系统疾病', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1002625, 604601, 221677, 185794, 185145, 178140, 132892, 130607, 115168, 91317, 3298],
		  riskFactors: ['高血压', '抽烟', '高血糖', '肥胖', '高胆固醇', '空气污染（室内和室外）', '饮食含盐量高', '水果饮食偏少', '二手烟', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [641143, 638003, 527500, 440815, 249746, 211876, 138216, 126286, 80423, 76754, 3298] },
		 {id: 129,
		  name: "塞舌尔",
		  lifeExpectancy: 73.4,
		  demographics: [15951, 13607, 13698, 14627, 14883, 12766, 7366, 3182, 1661],
		  majorCauses: ['心血管疾病', '癌症', '下呼吸道感染', '消化系统疾病', '肾脏疾病', '痴呆', '肝病', '呼吸疾病', '糖尿病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [236, 162, 73, 48, 41, 33, 27, 27, 18, 14, 0],
		  diseaseNames: ['心血管疾病', '癌症', '糖尿病，血液和内分泌疾病', '肌肉骨骼疾病', '腹泻和常见传染病', '其他非传染性疾病', '神经系统疾病', '消化系统疾病', '精神和物质使用障碍', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [5202, 4083, 2520, 1825, 1777, 1498, 1466, 1425, 1409, 1229, 0],
		  riskFactors: ['高血压', '高血糖', '肥胖', '抽烟', '高胆固醇', '空气污染（室内和室外）', '饮食含盐量高', '水果饮食偏少', '二手烟', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [4112, 3116, 2992, 2506, 1258, 1218, 1076, 653, 462, 422, 0] },
		 {id: 130,
		  name: "新加坡",
		  lifeExpectancy: 83.62,
		  demographics: [473440, 525276, 841606, 898862, 965359, 946886, 762636, 260127, 130150],
		  majorCauses: ['心血管疾病', '癌症', '下呼吸道感染', '痴呆', '呼吸疾病', '肾脏疾病', '消化系统疾病', '自杀', '肝病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [6161, 5449, 2696, 1617, 614, 594, 554, 496, 254, 197, 23],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '精神和物质使用障碍', '神经系统疾病', '意外伤害', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '腹泻和常见传染病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [131167, 124284, 117699, 96826, 61286, 58107, 49214, 45303, 37425, 28180, 371],
		  riskFactors: ['高血压', '高血糖', '抽烟', '肥胖', '饮食含盐量高', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '用药', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [70498, 67953, 67867, 60133, 36052, 34968, 31284, 16570, 14955, 10389, 371] },
		 {id: 131,
		  name: "斯洛伐克",
		  lifeExpectancy: 77.54,
		  demographics: [568394, 542764, 680528, 860773, 843980, 714201, 687712, 380061, 178599],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '消化系统疾病', '下呼吸道感染', '肝病', '呼吸疾病', '糖尿病', '肾脏疾病', '自杀', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [25216, 13227, 2992, 2748, 1680, 1527, 1107, 732, 713, 675, 28],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '意外伤害', '神经系统疾病', '消化系统疾病', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '其他非传染性疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [425950, 300811, 144022, 140687, 103170, 94371, 79871, 79683, 61368, 49558, 404],
		  riskFactors: ['高血压', '抽烟', '肥胖', '高胆固醇', '高血糖', '空气污染（室内和室外）', '饮食含盐量高', '水果饮食偏少', '饮食中蔬菜含量低', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [272632, 240554, 209249, 151462, 151283, 69635, 68488, 61685, 38061, 31734, 404] },
		 {id: 132,
		  name: "斯洛文尼亚",
		  lifeExpectancy: 81.32,
		  demographics: [212011, 193037, 211211, 290227, 303945, 302099, 281171, 172426, 112527],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '消化系统疾病', '呼吸疾病', '下呼吸道感染', '肝病', '自杀', '糖尿病', '肾脏疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [7450, 5907, 1534, 1058, 630, 601, 541, 430, 300, 213, 106],
		  diseaseNames: ['癌症', '心血管疾病', '意外伤害', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '消化系统疾病', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [114870, 105868, 63618, 56464, 42850, 32756, 29060, 29039, 24407, 21852, 1388],
		  riskFactors: ['抽烟', '高血压', '肥胖', '高血糖', '高胆固醇', '空气污染（室内和室外）', '饮食含盐量高', '水果饮食偏少', '用药', '饮食中蔬菜含量低', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [82245, 64747, 60624, 48836, 28166, 19537, 17406, 9380, 9341, 8879, 1388] },
		 {id: 133,
		  name: "索马里",
		  lifeExpectancy: 57.4,
		  demographics: [5094110, 3837600, 2580391, 1477525, 1036888, 713771, 450111, 201592, 50918],
		  majorCauses: ['心血管疾病', '下呼吸道感染', '结核', '新生儿疾病', '腹泻病', '癌症', '冲突', '道路伤害', '消化系统疾病', '营养不足', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [18048, 13033, 12697, 12265, 10548, 9299, 5445, 5154, 4786, 3435, 67],
		  diseaseNames: ['腹泻和常见传染病', '新生儿疾病', '艾滋病毒/艾滋病与结核病', '心血管疾病', '营养不足', '其他非传染性疾病', '癌症', '运输伤害', '意外伤害', '其他传染病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1602542, 1125637, 532931, 506577, 500937, 389547, 329509, 315175, 283153, 241549, 1434],
		  riskFactors: ['浪费孩子', '空气污染（室内和室外）', '不安全的水源', '儿童发育不良', '不安全的卫生', '高血压', '儿童发育迟缓', '高血糖', '非独家母乳喂养', '缺铁', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [1406987, 647809, 644927, 524574, 496043, 313258, 304365, 296970, 210379, 188299, 1434] },
		 {id: 134,
		  name: "南非",
		  lifeExpectancy: 64.13,
		  demographics: [11581615, 10240605, 10231760, 9942466, 6845747, 4794113, 3068429, 1430792, 422740],
		  majorCauses: ['HIV爱滋病', '心血管疾病', '癌症', '下呼吸道感染', '糖尿病', '结核', '呼吸疾病', '杀人', '道路伤害', '腹泻病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [135399, 76671, 48637, 26529, 22654, 19624, 18132, 15701, 15504, 14302, 524],
		  diseaseNames: ['艾滋病毒/艾滋病与结核病', '腹泻和常见传染病', '心血管疾病', '糖尿病，血液和内分泌疾病', '癌症', '新生儿疾病', '精神和物质使用障碍', '运输伤害', '人际暴力', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [10033858, 2145400, 1721968, 1712504, 1275456, 1164989, 864880, 862779, 862716, 779758, 10024],
		  riskFactors: ['高血糖', '肥胖', '高血压', '抽烟', '空气污染（室内和室外）', '浪费孩子', '不安全的水源', '水果饮食偏少', '用药', '高胆固醇', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [1646278, 1454452, 1274406, 960155, 799354, 602865, 505677, 426733, 396322, 344011, 10024] },
		 {id: 135,
		  name: "韩国",
		  lifeExpectancy: 83.03,
		  demographics: [4240885, 4886624, 6797905, 7196849, 8330006, 8442921, 6135717, 3444643, 1749770],
		  majorCauses: ['癌症', '心血管疾病', '痴呆', '消化系统疾病', '自杀', '呼吸疾病', '下呼吸道感染', '糖尿病', '肝病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [92548, 66787, 31554, 16084, 15228, 13973, 13444, 11719, 9447, 6643, 269],
		  diseaseNames: ['癌症', '肌肉骨骼疾病', '心血管疾病', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '神经系统疾病', '意外伤害', '自残', '呼吸疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1936073, 1435379, 1193979, 898163, 883625, 861525, 659048, 527829, 491707, 453457, 3906],
		  riskFactors: ['抽烟', '高血糖', '高血压', '肥胖', '空气污染（室内和室外）', '饮食含盐量高', '高胆固醇', '水果饮食偏少', '用药', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [1272299, 1121507, 575007, 528944, 422295, 305748, 271902, 206364, 158057, 115893, 3906] },
		 {id: 136,
		  name: "西班牙",
		  lifeExpectancy: 83.56,
		  demographics: [4340417, 4682339, 4652133, 6158281, 7935505, 6944643, 5200462, 3921750, 2901252],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '呼吸疾病', '消化系统疾病', '下呼吸道感染', '肾脏疾病', '糖尿病', '肝病', '帕金森综合症'],
		  majorDeaths: [123577, 115657, 51759, 33490, 21593, 12941, 10605, 8292, 8132, 5808],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '呼吸疾病', '意外伤害', '其他非传染性疾病', '消化系统疾病'],
		  diseaseDALYs: [2182632, 1682048, 1265974, 1243119, 950283, 660386, 588589, 549012, 475533, 448367],
		  riskFactors: ['抽烟', '高血糖', '高血压', '肥胖', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '用药', '低体力活动', '二手烟'],
		  riskDALYs: [1544708, 985420, 979221, 949682, 385742, 295600, 163174, 156687, 135357, 120071] },
		 {id: 137,
		  name: "斯里蘭卡",
		  lifeExpectancy: 76.98,
		  demographics: [3383992, 3369304, 2906780, 2883558, 2848798, 2533919, 1966154, 1080639, 350590],
		  majorCauses: ['心血管疾病', '癌症', '呼吸疾病', '糖尿病', '痴呆', '消化系统疾病', '下呼吸道感染', '自杀', '肾脏疾病', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [41867, 16628, 12267, 11537, 5971, 5246, 4986, 4523, 4512, 4021, 10],
		  diseaseNames: ['心血管疾病', '糖尿病，血液和内分泌疾病', '癌症', '肌肉骨骼疾病', '精神和物质使用障碍', '呼吸疾病', '神经系统疾病', '其他非传染性疾病', '腹泻和常见传染病', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [880238, 528668, 417142, 363658, 323956, 317010, 296913, 243702, 217443, 207042, 160],
		  riskFactors: ['高血糖', '高血压', '肥胖', '抽烟', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '饮食含盐量高', '饮食中蔬菜含量低', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [776768, 569841, 392912, 342663, 285535, 251275, 189307, 182848, 122999, 85925, 160] },
		 {id: 138,
		  name: "苏丹",
		  lifeExpectancy: 65.31,
		  demographics: [11957900, 9925896, 7382380, 5059889, 3624817, 2465268, 1480214, 702966, 213907],
		  majorCauses: ['心血管疾病', '新生儿疾病', '癌症', '道路伤害', '下呼吸道感染', '腹泻病', '呼吸疾病', 'HIV爱滋病', '消化系统疾病', '痴呆', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [69012, 25224, 15171, 10692, 9402, 8236, 5902, 5296, 5148, 4396, 170],
		  diseaseNames: ['新生儿疾病', '其他非传染性疾病', '心血管疾病', '腹泻和常见传染病', '运输伤害', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '意外伤害', '肌肉骨骼疾病', '神经系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [2412123, 1787062, 1725565, 1342405, 726662, 718901, 647654, 608911, 559545, 487047, 3446],
		  riskFactors: ['高血压', '浪费孩子', '肥胖', '空气污染（室内和室外）', '不安全的水源', '高血糖', '高胆固醇', '不安全的卫生', '水果饮食偏少', '缺铁', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [1049467, 1019444, 733013, 703277, 649044, 624608, 517119, 512310, 304955, 281543, 3446] },
		 {id: 139,
		  name: "苏里南",
		  lifeExpectancy: 71.68,
		  demographics: [104982, 101957, 95327, 81591, 72819, 63673, 35048, 18175, 7791],
		  majorCauses: ['心血管疾病', '癌症', '消化系统疾病', '糖尿病', '肾脏疾病', '下呼吸道感染', '痴呆', '自杀', '新生儿疾病', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [1396, 666, 243, 226, 209, 182, 170, 147, 144, 124, 1],
		  diseaseNames: ['心血管疾病', '糖尿病，血液和内分泌疾病', '癌症', '新生儿疾病', '精神和物质使用障碍', '其他非传染性疾病', '腹泻和常见传染病', '神经系统疾病', '肌肉骨骼疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [30501, 17214, 16906, 14702, 10533, 9951, 9783, 9038, 8792, 7928, 17],
		  riskFactors: ['高血糖', '肥胖', '高血压', '抽烟', '空气污染（室内和室外）', '高胆固醇', '水果饮食偏少', '饮食中蔬菜含量低', '用药', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [22098, 21406, 17697, 13435, 7920, 6442, 4554, 4009, 2483, 2435, 17] },
		 {id: 140,
		  name: "斯威士兰",
		  lifeExpectancy: 60.19,
		  demographics: [288502, 273125, 212361, 158383, 99646, 50414, 36433, 22204, 7065],
		  majorCauses: ['HIV爱滋病', '心血管疾病', '癌症', '下呼吸道感染', '糖尿病', '腹泻病', '结核', '道路伤害', '新生儿疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [2506, 1465, 844, 674, 584, 545, 521, 371, 360, 324, 2],
		  diseaseNames: ['艾滋病毒/艾滋病与结核病', '腹泻和常见传染病', '糖尿病，血液和内分泌疾病', '心血管疾病', '新生儿疾病', '癌症', '运输伤害', '意外伤害', '其他非传染性疾病', '人际暴力', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [277199, 120264, 39005, 38330, 36491, 26189, 23874, 18538, 16601, 16543, 39],
		  riskFactors: ['高血糖', '肥胖', '不安全的水源', '高血压', '浪费孩子', '空气污染（室内和室外）', '不安全的卫生', '抽烟', '用药', '儿童发育不良', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [44001, 35825, 29513, 27107, 24991, 22925, 21591, 15768, 8741, 8128, 39] },
		 {id: 141,
		  name: "瑞典",
		  lifeExpectancy: 82.8,
		  demographics: [1191245, 1106232, 1304961, 1289302, 1277210, 1280608, 1097278, 967449, 522106],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '呼吸疾病', 'COVID-19，直到2020年5月27日', '消化系统疾病', '下呼吸道感染', '糖尿病', '肾脏疾病', '自杀', '帕金森综合症'],
		  majorDeaths: [34164, 24053, 9660, 4518, 4125, 3034, 2903, 1722, 1461, 1395, 1213],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '意外伤害', '呼吸疾病', '其他非传染性疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [446549, 436415, 277268, 240709, 211399, 139367, 139276, 136083, 110778, 73435, 52985],
		  riskFactors: ['抽烟', '高血糖', '高血压', '肥胖', '高胆固醇', 'COVID-19，直到2020年5月27日', '饮食含盐量高', '空气污染（室内和室外）', '水果饮食偏少', '用药', '低体力活动'],
		  riskDALYs: [284244, 257193, 248332, 202521, 123616, 52985, 45905, 41439, 40058, 39436, 38229] },
		 {id: 142,
		  name: "瑞士",
		  lifeExpectancy: 83.78,
		  demographics: [875799, 835663, 1047321, 1211148, 1177086, 1309842, 953874, 731996, 448632],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '呼吸疾病', '消化系统疾病', '下呼吸道感染', 'COVID-19，直到2020年5月27日', '肾脏疾病', '自杀', '糖尿病', '肝病'],
		  majorDeaths: [21280, 17882, 7597, 2816, 2641, 1697, 1647, 1558, 1133, 1123, 940],
		  diseaseNames: ['癌症', '肌肉骨骼疾病', '心血管疾病', '神经系统疾病', '精神和物质使用障碍', '意外伤害', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '呼吸疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [337817, 307335, 263828, 185793, 166939, 115288, 104830, 91308, 86577, 60915, 21509],
		  riskFactors: ['抽烟', '高血糖', '肥胖', '高血压', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '用药', '饮食含盐量高', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [242301, 180978, 138338, 135271, 84308, 47268, 32555, 30843, 25405, 23257, 21509] },
		 {id: 143,
		  name: "叙利亚",
		  lifeExpectancy: 72.7,
		  demographics: [3569815, 3299311, 3073670, 2832030, 1819810, 1234238, 769970, 334158, 137130],
		  majorCauses: ['心血管疾病', '冲突', '癌症', '痴呆', '呼吸疾病', '肾脏疾病', '消化系统疾病', '恐怖主义', '下呼吸道感染', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [41380, 41378, 8795, 3157, 2994, 2257, 2139, 2026, 1946, 1748, 4],
		  diseaseNames: ['冲突与恐怖主义', '心血管疾病', '肌肉骨骼疾病', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '癌症', '其他非传染性疾病', '神经系统疾病', '腹泻和常见传染病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [3450747, 966983, 302387, 301942, 252434, 252051, 237494, 235115, 169355, 164278, 77],
		  riskFactors: ['高血压', '肥胖', '高血糖', '高胆固醇', '抽烟', '空气污染（室内和室外）', '水果饮食偏少', '饮食中蔬菜含量低', '用药', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [568413, 461284, 369488, 308024, 302142, 225934, 164138, 128383, 106175, 89597, 77] },
		 {id: 144,
		  name: "台湾",
		  lifeExpectancy: 80.46,
		  demographics: [2037909, 2275933, 3158514, 3637865, 3739295, 3676703, 2995888, 1399598, 852176],
		  majorCauses: ['癌症', '心血管疾病', '下呼吸道感染', '痴呆', '消化系统疾病', '糖尿病', '呼吸疾病', '肾脏疾病', '肝病', '自杀', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [53165, 40528, 13115, 12814, 10313, 9522, 9474, 6743, 6510, 4355, 7],
		  diseaseNames: ['癌症', '心血管疾病', '糖尿病，血液和内分泌疾病', '肌肉骨骼疾病', '呼吸疾病', '神经系统疾病', '精神和物质使用障碍', '消化系统疾病', '其他非传染性疾病', '运输伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1180273, 799276, 675740, 496956, 391306, 372657, 354883, 287510, 263068, 203754, 101],
		  riskFactors: ['抽烟', '高血糖', '肥胖', '高血压', '空气污染（室内和室外）', '高胆固醇', '用药', '二手烟', '饮食含盐量高', '水果饮食偏少', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [717421, 668199, 554479, 456764, 301189, 196544, 159397, 118790, 116679, 111020, 101] },
		 {id: 145,
		  name: "塔吉克斯坦",
		  lifeExpectancy: 71.1,
		  demographics: [2521647, 1740863, 1656860, 1336885, 861056, 686415, 358651, 111823, 46823],
		  majorCauses: ['心血管疾病', '下呼吸道感染', '癌症', '新生儿疾病', '消化系统疾病', '腹泻病', '肝病', '呼吸疾病', '糖尿病', '痴呆', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [18269, 4902, 4721, 3672, 2157, 1783, 1536, 1464, 1323, 1289, 46],
		  diseaseNames: ['腹泻和常见传染病', '心血管疾病', '新生儿疾病', '其他非传染性疾病', '意外伤害', '癌症', '神经系统疾病', '糖尿病，血液和内分泌疾病', '消化系统疾病', '精神和物质使用障碍', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [465754, 410475, 358569, 211958, 172689, 156895, 126736, 112026, 108010, 104828, 978],
		  riskFactors: ['浪费孩子', '高血压', '空气污染（室内和室外）', '高血糖', '肥胖', '抽烟', '高胆固醇', '不安全的水源', '水果饮食偏少', '不安全的卫生', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [324745, 259292, 240715, 228221, 143717, 126773, 104585, 103889, 93823, 93502, 978] },
		 {id: 146,
		  name: "坦桑尼亚",
		  lifeExpectancy: 65.46,
		  demographics: [17990384, 13636144, 9575102, 6938129, 4635689, 2803032, 1556334, 710015, 160632],
		  majorCauses: ['心血管疾病', '新生儿疾病', '下呼吸道感染', 'HIV爱滋病', '癌症', '结核', '疟疾', '腹泻病', '消化系统疾病', '糖尿病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [44175, 34523, 33486, 28299, 27864, 20391, 15325, 15196, 12862, 7084, 21],
		  diseaseNames: ['腹泻和常见传染病', '新生儿疾病', '艾滋病毒/艾滋病与结核病', '其他非传染性疾病', '疟疾和被忽视的热带病', '心血管疾病', '营养不足', '癌症', '意外伤害', '糖尿病，血液和内分泌疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [4552138, 3263525, 3045845, 2349773, 1408015, 1071877, 1055921, 930207, 781168, 744072, 470],
		  riskFactors: ['浪费孩子', '空气污染（室内和室外）', '高血压', '不安全的水源', '高血糖', '不安全的卫生', '缺铁', '抽烟', '肥胖', '儿童发育不良', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [1593860, 1303846, 708742, 677911, 596951, 509350, 490643, 425930, 416383, 366069, 470] },
		 {id: 147,
		  name: "泰国",
		  lifeExpectancy: 77.15,
		  demographics: [7548496, 8629471, 9617196, 9351071, 11070365, 10557509, 7301625, 3702813, 1847035],
		  majorCauses: ['癌症', '心血管疾病', '下呼吸道感染', '痴呆', '消化系统疾病', '肾脏疾病', '呼吸疾病', 'HIV爱滋病', '道路伤害', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [102596, 102583, 36188, 31550, 27266, 21922, 19813, 19372, 19183, 17239, 57],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '糖尿病，血液和内分泌疾病', '神经系统疾病', '运输伤害', '精神和物质使用障碍', '腹泻和常见传染病', '消化系统疾病', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [2520200, 2359442, 1629403, 1474520, 1151289, 1131258, 1102666, 1030793, 842762, 795653, 867],
		  riskFactors: ['肥胖', '高血糖', '抽烟', '高血压', '空气污染（室内和室外）', '高胆固醇', '用药', '饮食含盐量高', '水果饮食偏少', '饮食中蔬菜含量低', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [1544002, 1503953, 1495743, 1392361, 817709, 595479, 522351, 480904, 337081, 334390, 867] },
		 {id: 148,
		  name: "多哥",
		  lifeExpectancy: 61.04,
		  demographics: [2311118, 1866015, 1338976, 1041497, 716177, 432524, 246902, 107658, 21492],
		  majorCauses: ['心血管疾病', '疟疾', '新生儿疾病', 'HIV爱滋病', '下呼吸道感染', '癌症', '腹泻病', '结核', '消化系统疾病', '呼吸疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [7581, 6904, 4066, 3875, 3742, 3619, 3202, 2349, 1728, 1294, 13],
		  diseaseNames: ['腹泻和常见传染病', '疟疾和被忽视的热带病', '新生儿疾病', '艾滋病毒/艾滋病与结核病', '心血管疾病', '其他非传染性疾病', '糖尿病，血液和内分泌疾病', '营养不足', '癌症', '精神和物质使用障碍', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [537846, 508891, 393410, 341328, 204478, 196801, 129842, 113892, 110100, 95415, 290],
		  riskFactors: ['浪费孩子', '不安全的水源', '空气污染（室内和室外）', '不安全的卫生', '高血压', '高血糖', '儿童发育不良', '肥胖', '缺铁', '水果饮食偏少', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [220449, 185196, 160336, 135929, 134583, 94600, 76138, 68658, 58437, 51784, 290] },
		 {id: 149,
		  name: "東加",
		  lifeExpectancy: 70.91,
		  demographics: [24631, 23270, 16616, 12190, 10251, 8452, 5150, 2759, 1178],
		  majorCauses: ['心血管疾病', '癌症', '糖尿病', '呼吸疾病', '消化系统疾病', '肾脏疾病', '下呼吸道感染', '痴呆', '肝病', '新生儿疾病'],
		  majorDeaths: [168, 130, 89, 42, 40, 38, 37, 30, 20, 15],
		  diseaseNames: ['糖尿病，血液和内分泌疾病', '心血管疾病', '癌症', '腹泻和常见传染病', '呼吸疾病', '肌肉骨骼疾病', '新生儿疾病', '意外伤害', '其他非传染性疾病', '精神和物质使用障碍'],
		  diseaseDALYs: [4546, 3934, 3332, 2361, 1709, 1669, 1572, 1366, 1351, 1273],
		  riskFactors: ['高血糖', '肥胖', '高血压', '抽烟', '空气污染（室内和室外）', '高胆固醇', '水果饮食偏少', '二手烟', '饮食含盐量高', '饮食中蔬菜含量低'],
		  riskDALYs: [5164, 4209, 2848, 2083, 1566, 1338, 887, 702, 638, 590] },
		 {id: 150,
		  name: "突尼西亞",
		  lifeExpectancy: 76.7,
		  demographics: [2003420, 1617133, 1752255, 1915913, 1535771, 1342758, 920265, 405873, 201331],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '道路伤害', '呼吸疾病', '糖尿病', '消化系统疾病', '下呼吸道感染', '肾脏疾病', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [34122, 9409, 3940, 3669, 2497, 1934, 1776, 1650, 1645, 1001, 48],
		  diseaseNames: ['心血管疾病', '糖尿病，血液和内分泌疾病', '肌肉骨骼疾病', '癌症', '精神和物质使用障碍', '神经系统疾病', '运输伤害', '其他非传染性疾病', '新生儿疾病', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [585199, 248559, 245020, 222652, 214692, 184184, 167150, 140000, 121829, 113084, 792],
		  riskFactors: ['高血压', '高血糖', '肥胖', '抽烟', '高胆固醇', '空气污染（室内和室外）', '用药', '水果饮食偏少', '二手烟', '低体力活动', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [340549, 294028, 293805, 263027, 156922, 137558, 97722, 75056, 53044, 46210, 792] },
		 {id: 151,
		  name: "土耳其",
		  lifeExpectancy: 77.69,
		  demographics: [13501499, 13585939, 13087611, 12748548, 11221844, 8664742, 5968559, 3216491, 1434374],
		  majorCauses: ['心血管疾病', '癌症', '呼吸疾病', '痴呆', '肾脏疾病', '糖尿病', '下呼吸道感染', '消化系统疾病', '道路伤害', '新生儿疾病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [146584, 92760, 30377, 25063, 15153, 14803, 11029, 10147, 8604, 7759, 4397],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '其他非传染性疾病', '神经系统疾病', '呼吸疾病', '新生儿疾病', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [2919631, 2354596, 1872089, 1592440, 1393202, 1299523, 1292062, 1093030, 967562, 663606, 71536],
		  riskFactors: ['抽烟', '肥胖', '高血压', '高血糖', '空气污染（室内和室外）', '高胆固醇', '用药', '二手烟', '低体力活动', '水果饮食偏少', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [2226441, 2042748, 1847649, 1636498, 1052115, 748929, 537754, 318850, 250390, 233411, 71536] },
		 {id: 152,
		  name: "土库曼斯坦",
		  lifeExpectancy: 68.19,
		  demographics: [1319649, 986539, 1030876, 931108, 681290, 527222, 315752, 97685, 51973],
		  majorCauses: ['心血管疾病', '癌症', '消化系统疾病', '肝病', '下呼吸道感染', '新生儿疾病', '痴呆', '糖尿病', '肾脏疾病', '结核'],
		  majorDeaths: [17557, 3525, 2714, 2341, 1206, 1119, 1085, 699, 632, 515],
		  diseaseNames: ['心血管疾病', '腹泻和常见传染病', '新生儿疾病', '消化系统疾病', '癌症', '其他非传染性疾病', '糖尿病，血液和内分泌疾病', '肝病', '意外伤害', '神经系统疾病'],
		  diseaseDALYs: [412359, 156211, 117894, 116563, 109893, 98719, 98581, 90861, 82484, 66974],
		  riskFactors: ['高血压', '肥胖', '高血糖', '高胆固醇', '抽烟', '空气污染（室内和室外）', '水果饮食偏少', '饮食含盐量高', '浪费孩子', '二手烟'],
		  riskDALYs: [261803, 192851, 190537, 127973, 124986, 79461, 71543, 58734, 39112, 37650] },
		 {id: 153,
		  name: "乌干达",
		  lifeExpectancy: 63.37,
		  demographics: [14582039, 11067913, 7564888, 4881270, 2997016, 1765499, 930221, 391414, 89327],
		  majorCauses: ['新生儿疾病', 'HIV爱滋病', '心血管疾病', '疟疾', '癌症', '下呼吸道感染', '结核', '腹泻病', '消化系统疾病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [26523, 25920, 22888, 22237, 20659, 14831, 14181, 11833, 8742, 5826, 0],
		  diseaseNames: ['腹泻和常见传染病', '艾滋病毒/艾滋病与结核病', '新生儿疾病', '疟疾和被忽视的热带病', '其他非传染性疾病', '癌症', '其他传染病', '营养不足', '心血管疾病', '精神和物质使用障碍', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [3490823, 3014071, 2525060, 1935911, 1064399, 733907, 669265, 596318, 591241, 543171, 0],
		  riskFactors: ['浪费孩子', '不安全的水源', '空气污染（室内和室外）', '不安全的卫生', '高血糖', '高血压', '儿童发育不良', '缺铁', '抽烟', '肥胖', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [862388, 642771, 631450, 504195, 368985, 360544, 304798, 239348, 179745, 179650, 0] },
		 {id: 154,
		  name: "乌克兰",
		  lifeExpectancy: 72.06,
		  demographics: [4688013, 4279672, 5165651, 7259196, 6313137, 6006155, 5470675, 2961499, 1849645],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '消化系统疾病', '肝病', '自杀', '呼吸疾病', '下呼吸道感染', '饮酒障碍', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [427321, 96034, 34913, 30537, 20083, 13679, 11366, 9215, 8270, 6681, 644],
		  diseaseNames: ['心血管疾病', '癌症', '消化系统疾病', '意外伤害', '肌肉骨骼疾病', '神经系统疾病', '肝病', '精神和物质使用障碍', '其他非传染性疾病', '自残', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [7982965, 2712757, 1323796, 1323359, 1163398, 1059750, 816301, 778737, 677804, 651836, 8904],
		  riskFactors: ['高血压', '抽烟', '肥胖', '高胆固醇', '高血糖', '水果饮食偏少', '空气污染（室内和室外）', '饮食含盐量高', '低体力活动', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [5022720, 3420787, 2728117, 2680474, 2115808, 1322553, 1176016, 772782, 738698, 510646, 8904] },
		 {id: 155,
		  name: "阿拉伯联合酋长国",
		  lifeExpectancy: 77.97,
		  demographics: [1006422, 835037, 2150663, 3072012, 1655625, 777310, 209301, 52385, 11771],
		  majorCauses: ['心血管疾病', '癌症', '道路伤害', '呼吸疾病', '糖尿病', '肾脏疾病', '吸毒障碍', '自杀', '消化系统疾病', '下呼吸道感染', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [7347, 5107, 3649, 1554, 1145, 829, 629, 599, 589, 586, 253],
		  diseaseNames: ['心血管疾病', '肌肉骨骼疾病', '运输伤害', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '癌症', '意外伤害', '神经系统疾病', '呼吸疾病', '其他非传染性疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [244834, 208816, 191799, 179512, 178787, 172241, 136126, 124005, 118059, 108280, 7365],
		  riskFactors: ['肥胖', '用药', '高血糖', '高血压', '高胆固醇', '抽烟', '空气污染（室内和室外）', '水果饮食偏少', '饮食中蔬菜含量低', '饮食含盐量高', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [250177, 220805, 177587, 159731, 151202, 116323, 92221, 46473, 33179, 30313, 7365] },
		 {id: 156,
		  name: "英国",
		  lifeExpectancy: 81.32,
		  demographics: [8065283, 7569160, 8630614, 9203569, 8624679, 9138365, 7206475, 5673457, 3418559],
		  majorCauses: ['癌症', '心血管疾病', '痴呆', '呼吸疾病', 'COVID-19，直到2020年5月27日', '下呼吸道感染', '消化系统疾病', '肝病', '帕金森综合症', '肾脏疾病', '自杀'],
		  majorDeaths: [179856, 176516, 63894, 47298, 37048, 36952, 29640, 9258, 7334, 6766, 5778],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '神经系统疾病', '精神和物质使用障碍', '呼吸疾病', '其他非传染性疾病', '意外伤害', '糖尿病，血液和内分泌疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [3323621, 2620719, 2099648, 1589106, 1296572, 1217869, 789427, 782490, 740272, 738202, 481718],
		  riskFactors: ['抽烟', '肥胖', '高血压', '高血糖', '高胆固醇', 'COVID-19，直到2020年5月27日', '空气污染（室内和室外）', '用药', '水果饮食偏少', '低体力活动', '饮食中蔬菜含量低'],
		  riskDALYs: [2021182, 1448311, 1337544, 1293288, 752234, 481718, 480135, 424409, 362994, 219675, 219262] },
		 {id: 157,
		  name: "美国",
		  lifeExpectancy: 78.86,
		  demographics: [39891845, 42398071, 46179065, 43980069, 40288440, 42557686, 37845098, 23009234, 12915409],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '呼吸疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日', '下呼吸道感染', '肾脏疾病', '糖尿病', '吸毒障碍', '肝病'],
		  majorDeaths: [902270, 699394, 258587, 196983, 114419, 98916, 93792, 84944, 68558, 67629, 62493],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '糖尿病，血液和内分泌疾病', '精神和物质使用障碍', '神经系统疾病', '呼吸疾病', '其他非传染性疾病', '意外伤害', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [15273136, 14368167, 9550395, 7190242, 7176630, 6691294, 5887644, 3992949, 3787971, 3546678, 1363568],
		  riskFactors: ['肥胖', '抽烟', '高血糖', '高血压', '用药', '高胆固醇', '空气污染（室内和室外）', '饮食含盐量高', '水果饮食偏少', 'COVID-19，直到2020年5月27日', '饮食中蔬菜含量低'],
		  riskDALYs: [11440537, 10405127, 9566522, 7850854, 6465949, 4010823, 2432143, 1978011, 1966068, 1363568, 1249128] },
		 {id: 158,
		  name: "乌拉圭",
		  lifeExpectancy: 77.91,
		  demographics: [473133, 483284, 512458, 458714, 451252, 390115, 321685, 216752, 154338],
		  majorCauses: ['心血管疾病', '癌症', '痴呆', '呼吸疾病', '下呼吸道感染', '消化系统疾病', '糖尿病', '肾脏疾病', '自杀', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [9912, 9576, 2363, 2065, 1476, 1455, 796, 787, 676, 609, 22],
		  diseaseNames: ['癌症', '心血管疾病', '肌肉骨骼疾病', '精神和物质使用障碍', '神经系统疾病', '糖尿病，血液和内分泌疾病', '意外伤害', '呼吸疾病', '其他非传染性疾病', '消化系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [191969, 155889, 81966, 64215, 59439, 57322, 54943, 48981, 48284, 34011, 292],
		  riskFactors: ['抽烟', '高血糖', '肥胖', '高血压', '高胆固醇', '空气污染（室内和室外）', '饮食含盐量高', '水果饮食偏少', '饮食中蔬菜含量低', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [122819, 102193, 92697, 90942, 35618, 25552, 24250, 22019, 16300, 16013, 292] },
		 {id: 159,
		  name: "乌兹别克斯坦",
		  lifeExpectancy: 71.72,
		  demographics: [6664494, 5370904, 6061979, 5409605, 3820670, 3028065, 1810321, 546389, 269288],
		  majorCauses: ['心血管疾病', '癌症', '消化系统疾病', '肝病', '下呼吸道感染', '糖尿病', '新生儿疾病', '痴呆', '呼吸疾病', '道路伤害', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [115263, 19020, 12837, 10974, 9749, 6468, 5348, 4578, 4239, 3990, 14],
		  diseaseNames: ['心血管疾病', '腹泻和常见传染病', '癌症', '新生儿疾病', '糖尿病，血液和内分泌疾病', '消化系统疾病', '意外伤害', '神经系统疾病', '其他非传染性疾病', '肌肉骨骼疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [2443175, 886397, 597123, 595292, 558138, 526686, 503123, 443174, 434858, 410622, 275],
		  riskFactors: ['高血压', '高血糖', '肥胖', '高胆固醇', '空气污染（室内和室外）', '抽烟', '水果饮食偏少', '饮食含盐量高', '浪费孩子', '缺铁', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [1496057, 1280895, 1076363, 745685, 642961, 621056, 458090, 302480, 258512, 232779, 275] },
		 {id: 160,
		  name: "瓦努阿图",
		  lifeExpectancy: 70.47,
		  demographics: [80126, 64634, 50207, 39556, 28333, 19760, 10910, 4727, 1629],
		  majorCauses: ['心血管疾病', '癌症', '呼吸疾病', '消化系统疾病', '下呼吸道感染', '糖尿病', '新生儿疾病', '肾脏疾病', '肝病', '道路伤害'],
		  majorDeaths: [797, 274, 146, 130, 120, 94, 87, 67, 59, 52],
		  diseaseNames: ['心血管疾病', '腹泻和常见传染病', '糖尿病，血液和内分泌疾病', '新生儿疾病', '癌症', '呼吸疾病', '其他非传染性疾病', '意外伤害', '消化系统疾病', '肌肉骨骼疾病'],
		  diseaseDALYs: [22223, 12105, 10112, 8331, 8231, 6302, 6104, 5833, 4745, 3980],
		  riskFactors: ['高血压', '高血糖', '肥胖', '空气污染（室内和室外）', '高胆固醇', '抽烟', '水果饮食偏少', '饮食中蔬菜含量低', '浪费孩子', '饮食含盐量高'],
		  riskDALYs: [14567, 13135, 10947, 8110, 7425, 7106, 4631, 3783, 3261, 2428] },
		 {id: 161,
		  name: "委内瑞拉",
		  lifeExpectancy: 72.06,
		  demographics: [5161179, 5131622, 4293108, 4112119, 3551367, 2964615, 1955306, 946456, 400056],
		  majorCauses: ['心血管疾病', '癌症', '杀人', '糖尿病', '肾脏疾病', '道路伤害', '痴呆', '消化系统疾病', '呼吸疾病', '下呼吸道感染', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [52708, 30238, 14760, 8670, 8403, 6988, 6898, 6881, 5694, 5184, 11],
		  diseaseNames: ['心血管疾病', '人际暴力', '癌症', '糖尿病，血液和内分泌疾病', '新生儿疾病', '精神和物质使用障碍', '其他非传染性疾病', '神经系统疾病', '运输伤害', '肌肉骨骼疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1039079, 868219, 779521, 639505, 499148, 436324, 413955, 410885, 409658, 399136, 186],
		  riskFactors: ['肥胖', '高血压', '高血糖', '抽烟', '高胆固醇', '空气污染（室内和室外）', '水果饮食偏少', '饮食中蔬菜含量低', '饮食含盐量高', '用药', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [762035, 749717, 686646, 426608, 301614, 252091, 161369, 145538, 118144, 113563, 186] },
		 {id: 162,
		  name: "越南",
		  lifeExpectancy: 75.4,
		  demographics: [15416497, 13451055, 15886425, 15977005, 13383787, 10911362, 6922468, 2640054, 1873454],
		  majorCauses: ['心血管疾病', '癌症', '呼吸疾病', '消化系统疾病', '痴呆', '糖尿病', '肝病', '道路伤害', '下呼吸道感染', '结核', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [201137, 120617, 35946, 29614, 28274, 23439, 22607, 21431, 18137, 17594, 0],
		  diseaseNames: ['心血管疾病', '癌症', '肌肉骨骼疾病', '糖尿病，血液和内分泌疾病', '神经系统疾病', '其他非传染性疾病', '意外伤害', '运输伤害', '精神和物质使用障碍', '腹泻和常见传染病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [4127692, 3149728, 1682582, 1573487, 1329423, 1253509, 1236854, 1231032, 1208151, 1133110, 0],
		  riskFactors: ['高血压', '高血糖', '抽烟', '空气污染（室内和室外）', '肥胖', '水果饮食偏少', '高胆固醇', '饮食含盐量高', '用药', '二手烟', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [2694716, 2423017, 2329745, 1363548, 953163, 929387, 794256, 787186, 650700, 441172, 0] },
		 {id: 163,
		  name: "世界",
		  lifeExpectancy: 72.58,
		  demographics: [1339127564, 1244883537, 1194975548, 1132908777, 967210641, 816097736, 575804788, 299355359, 143104251],
		  majorCauses: ['心血管疾病', '癌症', '呼吸疾病', '下呼吸道感染', '痴呆', '消化系统疾病', '新生儿疾病', '腹泻病', '糖尿病', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [17790949, 9556245, 3914196, 2558606, 2514619, 2377685, 1783770, 1569556, 1369849, 1322868, 350212],
		  diseaseNames: ['心血管疾病', '癌症', '腹泻和常见传染病', '新生儿疾病', '肌肉骨骼疾病', '糖尿病，血液和内分泌疾病', '其他非传染性疾病', '精神和物质使用障碍', '呼吸疾病', '神经系统疾病', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [362381389, 230815088, 229961383, 191193185, 136350616, 133747830, 123452995, 121240264, 111041442, 109462440, 5601995],
		  riskFactors: ['高血压', '抽烟', '高血糖', '空气污染（室内和室外）', '肥胖', '浪费孩子', '高胆固醇', '饮食含盐量高', '水果饮食偏少', '不安全的水源', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [215645558, 182157003, 167407681, 148834208, 144091083, 95632517, 93844026, 69981368, 64856023, 64282494, 5601995] },
		 {id: 164,
		  name: "也门",
		  lifeExpectancy: 66.12,
		  demographics: [7957248, 6628518, 5663615, 3953524, 2239232, 1382738, 848627, 387468, 100952],
		  majorCauses: ['心血管疾病', '新生儿疾病', '冲突', '癌症', '道路伤害', '腹泻病', '下呼吸道感染', '呼吸疾病', '消化系统疾病', '痴呆', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [53367, 18040, 16811, 11942, 9556, 8125, 6366, 4968, 3490, 2672, 49],
		  diseaseNames: ['新生儿疾病', '心血管疾病', '腹泻和常见传染病', '冲突与恐怖主义', '其他非传染性疾病', '营养不足', '运输伤害', '精神和物质使用障碍', '糖尿病，血液和内分泌疾病', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [1718808, 1355173, 1178751, 1006373, 896708, 855459, 598635, 485971, 459085, 415361, 1077],
		  riskFactors: ['浪费孩子', '高血压', '缺铁', '不安全的水源', '肥胖', '空气污染（室内和室外）', '高血糖', '高胆固醇', '抽烟', '儿童发育不良', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [831197, 701666, 686920, 546393, 459939, 459135, 435825, 422401, 370118, 365007, 1077] },
		 {id: 165,
		  name: "赞比亚",
		  lifeExpectancy: 63.89,
		  demographics: [5569170, 4426210, 3069086, 2117552, 1347824, 726745, 386102, 173103, 45242],
		  majorCauses: ['HIV爱滋病', '心血管疾病', '新生儿疾病', '下呼吸道感染', '癌症', '结核', '腹泻病', '消化系统疾病', '疟疾', '肝病', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [21807, 12157, 9688, 8979, 8826, 8307, 7748, 5040, 4673, 3257, 7],
		  diseaseNames: ['艾滋病毒/艾滋病与结核病', '腹泻和常见传染病', '新生儿疾病', '其他非传染性疾病', '疟疾和被忽视的热带病', '营养不足', '心血管疾病', '癌症', '糖尿病，血液和内分泌疾病', '意外伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [2030052, 1707416, 900812, 502967, 391788, 334898, 319041, 302693, 253262, 234132, 164],
		  riskFactors: ['浪费孩子', '不安全的水源', '空气污染（室内和室外）', '不安全的卫生', '高血糖', '儿童发育不良', '高血压', '儿童发育迟缓', '抽烟', '肥胖', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [631163, 411032, 344582, 309455, 221962, 182199, 176329, 130440, 126593, 118268, 164] },
		 {id: 166,
		  name: "津巴布韦",
		  lifeExpectancy: 61.49,
		  demographics: [4312155, 3456516, 2462905, 1862792, 1205778, 674792, 410758, 196977, 62799],
		  majorCauses: ['心血管疾病', 'HIV爱滋病', '下呼吸道感染', '结核', '癌症', '新生儿疾病', '腹泻病', '呼吸疾病', '消化系统疾病', '营养不足', 'COVID-19，直到2020年5月27日'],
		  majorDeaths: [16977, 16065, 12370, 11958, 11440, 8412, 4603, 3412, 3387, 3158, 4],
		  diseaseNames: ['艾滋病毒/艾滋病与结核病', '腹泻和常见传染病', '新生儿疾病', '心血管疾病', '癌症', '营养不足', '糖尿病，血液和内分泌疾病', '意外伤害', '其他非传染性疾病', '运输伤害', 'COVID-19，直到2020年5月27日'],
		  diseaseDALYs: [2112674, 1418231, 804919, 470598, 358516, 324526, 300375, 249593, 240049, 180995, 84],
		  riskFactors: ['浪费孩子', '空气污染（室内和室外）', '高血糖', '高血压', '抽烟', '不安全的水源', '肥胖', '不安全的卫生', '儿童发育不良', '水果饮食偏少', 'COVID-19，直到2020年5月27日'],
		  riskDALYs: [543888, 428451, 339950, 279958, 268280, 263176, 204466, 181818, 115425, 102441, 84] },
		],
  });
